import { TableAction } from '@fitness-force/enum';
import { CurrencyComponent } from '@fitness-force/grid-utility/currency';
// Using relative imports to avoid circular dependency within shared library
import { ClientGenderComponent } from '../components/data-grid/utility/client-gender/client-gender.component';
import { ClientRegularStatusComponent } from '../components/data-grid/utility/client-regular-status/client-regular-status.component';
import { ContractTermViewComponent } from '../components/data-grid/utility/contract-term-view/contract-term-view.component';
import { DateCellComponent } from '../components/data-grid/utility/date-cell/date-cell.component';
import { YesNoComponent } from '../components/data-grid/utility/yes-no/yes-no.component';
import { OnlineComponent } from '../components/data-grid/utility/online/online.component';
import { PaymentModeComponent } from '../components/data-grid/utility/payment-mode/payment-mode.component';
import { PaymentStatusComponent } from '../components/data-grid/utility/payment-status/payment-status.component';
import { ProspectInfoComponent } from '../components/data-grid/utility/prospect-info/prospect-info.component';
import { SubscriptionCategoryDisplayComponent } from '../components/data-grid/utility/subscription-category-display/subscription-category-display.component';
import { PaymentDetailsReportComponent } from '../components/data-grid/utility/payment-details-report/payment-details-report.component';
import { SubscriptionStatusComponent } from '../components/data-grid/utility/subscription-status/subscription-status.component';
import { BillingCycleComponent } from '../components/data-grid/utility/billing-cycle/billing-cycle.component';
import { TrackModeComponent } from '../components/data-grid/utility/track-mode/track-mode.component';
import { PrimarySecondaryComponent } from '../components/data-grid/utility/primary-secondary/primary-secondary.component';
import { StaffInfoReportComponent } from '../components/staff/staff-info-report/staff-info-report.component';
import { TaskTypeReportComponent } from '../components/data-grid/utility/task-type-report/task-type-report.component';
import { BehaviourViewComponent } from '../components/behaviour-view/behaviour-view.component';
import { AppointmentStatusComponent } from '../components/data-grid/utility/appointment-status/appointment-status.component';
import { OutcomeComponent } from '../components/data-grid/utility/outcome/outcome.component';
import { TaskCategoryCellComponent } from '../components/data-grid/utility/task-category/task-category-cell.component';
import { CheckInEventComponent } from '../components/data-grid/utility/check-in/check-in-event/check-in-event.component';
import { CheckInStatusComponent } from '../components/data-grid/utility/check-in/check-in-status/check-in-status.component';
import { TenantNameComponent } from '../components/data-grid/utility/tenant/tenant-name/tenant-name.component';
import { OpportunityStageComponent } from '../components/data-grid/utility/opportunity-stage/opportunity-stage.component';
import { InvoiceStatusComponent } from '../components/data-grid/utility/invoice-status/invoice-status.component';
import { ClassBookingStatusComponent } from '../components/data-grid/utility/class-booking-status/class-booking-status.component';
import { ClassStatusComponent } from '../components/data-grid/utility/class-status/class-status.component';
import { ClassUtilizationComponent } from '../components/data-grid/utility/class-utilization/class-utilization.component';
import { BalanceAgeBucketComponent } from '../components/data-grid/utility/balance-age-bucket/balance-age-bucket.component';
import { InvoiceDataComponent } from '../components/data-grid/utility/invoice-data/invoice-data.component';
import { ServiceValidityComponent } from '../components/data-grid/utility/service-validity/service-validity.component';
import { InvoiceTypeComponent } from '../components/data-grid/utility/invoice-type/invoice-type.component';
import { PercentageComponent } from '../components/data-grid/utility/percentage/percentage.component';
import { TransactionTypeComponent } from '../components/data-grid/utility/transaction-type/transaction-type.component';
import { CreditBalanceTypeComponent } from '../components/data-grid/utility/credit-balance-type/credit-balance-type.component';
import { ClientStatusComponent } from '../components/data-grid/utility/client-status/client-status.component';
import { CommunicationDirectionComponent } from '../components/data-grid/utility/communication-direction/communication-direction.component';
import { EmailStatusComponent } from '../components/data-grid/utility/email-status/email-status.component';
import { OwnershipLevelComponent } from '../components/data-grid/utility/ownership-level/ownership-level.component';
import { SmsTransactionTypeComponent } from '../components/data-grid/utility/sms-transaction-type/sms-transaction-type.component';
import { ClassPassComponent } from '../components/data-grid/utility/class-pass/class-pass.component';
import { FreezeTypeComponent } from '../components/data-grid/utility/freeze-type/freeze-type.component';
import { FreezeStatusComponent } from '../components/data-grid/utility/freeze-status/freeze-status.component';
import { RetryModeComponent } from '../components/data-grid/utility/retry-mode/retry-mode.component';
import { PaymentTokenStatusComponent } from '../components/data-grid/utility/payment-token-status/payment-token-status.component';
import { RefundReasonComponent } from '../components/data-grid/utility/refund-reason/refund-reason.component';

import { DateFormatedComponent } from '@fitness-force/grid-utility';
import { RefundStatusComponent } from '@fitness-force/refund';
import { LostReasonTypeComponent } from '../components/data-grid/utility/lost-reason-type/lost-reason-type.component';
import { StageNameComponent } from '../components/data-grid/utility/lost-reason-type/stage-name.component';
import { GuestPassStatusComponent } from '../components/data-grid/utility/guest-pass/guest-pass-status/guest-pass-status.component';
import { ClientInfoReportComponent } from '../components/data-grid/utility/prospect-info/client-info-report.component';
import { ActionsComponent } from '@fitness-force/grid-utility/action';
import { ReferralStatusComponent } from '../components/data-grid/utility/referral-status/referral-status.component';

export const ReportTableColumnData = [
  {
    report_key: 'ClientListReport',
    actions: [
      {
        label: 'Create Apportunity',
        class: 'p-button-text text-xs md:text-sm mb-1 xl:mb-2',
        type: 'button',
        actionType: TableAction.Opportunity,
        icon: 'fa fa-plus',
      },
      {
        label: 'Create Task',
        class: 'p-button-text text-xs md:text-sm mb-1 xl:mb-2',
        type: 'button',
        actionType: TableAction.Task,
        icon: 'fa fa-list',
      },
    ],
    columns: [
      {
        title: 'CLIENT NAME',
        classes: 'py-2   white-space-nowrap',
        sortable: true,
        filterable: true,
        dataProperty: 'clt_full_name',
        type: 'default',
        data: {},
      },
      {
        title: 'EMAIL',
        classes: 'py-2   white-space-nowrap',
        sortable: true,
        filterable: true,
        dataProperty: 'clt_emailid',
        type: 'default',
      },
      {
        title: 'MOBILE NO',
        classes: 'py-2   white-space-nowrap',
        sortable: true,
        filterable: true,
        dataProperty: 'clt_mobile_no',
        type: 'default',
      },
      {
        title: 'DATE OF BIRTH',
        classes: 'py-2   white-space-nowrap',
        sortable: true,
        filterable: true,
        dataProperty: 'clt_dateofbirth',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'clt_dateofbirth',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'GENDER',
        classes: 'py-2   white-space-nowrap',
        sortable: true,
        filterable: true,
        dataProperty: 'clt_gender',
        type: 'component',
        data: { name: ClientGenderComponent },
      },
      {
        title: 'CLIENT IRREGULAR',
        classes: 'py-2   white-space-nowrap',
        sortable: true,
        filterable: true,
        dataProperty: 'clt_is_irregular',
        type: 'component',
        data: { name: ClientRegularStatusComponent },
      },
    ],
  },

  {
    report_key: 'PaymentReport',
    actions: [
      {
        label: 'TABLE_ACTION_BTNS.CREATE_TASK',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.Task,
        icon: 'fa fa-list',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_EMAIL',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendEmail,
        icon: 'fa fa-envelope',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_SMS',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendSms,
        icon: 'fa fa-comments',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_WHATSAPP',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendWhatsApp,
        icon: 'fab fa-whatsapp',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_PUSH_NOTIFICATION',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendPushNotification,
        icon: 'fa fa-bell',
      },
    ],
    columns: [
      {
        title: 'MEMBER NAME',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_full_name',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
      {
        title: 'PAYMENT DATE',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'pymt_payment_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'pymt_payment_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'PAYMENT #',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'pymt_number_prefix',
        type: 'default',
      },
      {
        title: 'INVOICE DATE',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_issue_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'inv_issue_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Invoice #',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_number_prefix',
        type: 'component',
        data: {
          name: InvoiceDataComponent,
        },
      },
      {
        title: 'PAYMENT TYPE',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'pymt_log_is_online',
        type: 'component',
        data: {
          name: OnlineComponent,
          additionData: true,
          aData: { fetch_key: 'pymt_log_is_online' },
        },
      },
      {
        title: 'STATUS ',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'pymt_status',
        type: 'component',
        data: {
          name: PaymentStatusComponent,
          additionData: true,
          aData: { fetch_key: 'pymt_status', status_type: 'payment_status' },
        },
      },
      {
        title: 'AMOUNT PAID',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'pymt_amount_in_minor_curr',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'pymt_amount_in_minor_curr',
        },
      },
      {
        title: 'Auto Pay',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'pymt_log_is_recurring_collection',
        type: 'component',
        data: {
          name: YesNoComponent,
          additionData: true,
          aData: {
            fetch_key: 'pymt_log_is_recurring_collection',
            type: 'yes-no',
          },
        },
      },
      {
        title: 'PAYMENT MODE',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'pymt_log_paymode_level1',
        type: 'component',
        data: {
          name: PaymentModeComponent,
          additionData: true,
          aData: { fetch_key: 'pymt_log_paymode_level1' },
        },
      },

      {
        title: 'Payment Club',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'payment_at_club_id',
        type: 'component',
        data: {
          name: TenantNameComponent,
          additionData: true,
          aData: { fetch_key: 'payment_at_club_id' },
        },
      },
      {
        title: 'Payment For club',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'payment_for_club_id',
        type: 'component',
        data: {
          name: TenantNameComponent,
          additionData: true,
          aData: { fetch_key: 'payment_for_club_id' },
        },
      },

      {
        title: 'Void Reason',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'pymt_void_reason',
        type: 'default',
      },
      {
        title: 'Sales Rep',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'pymt_sales_rep_id',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'pymt_sales_rep', originalKey: false },
        },
      },
      {
        title: 'LAST UPDATED ON',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'pymt_updated_date',
        type: 'component',
        data: {
          name: DateCellComponent,
          additionData: true,
          aData: { fetch_key: 'pymt_updated_date', applytimezone: false },
        },
      },
      {
        title: 'LAST UPDATED BY	',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'pymt_updated_by',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'pymt_updated_by', originalKey: false },
        },
      },
    ],
  },
  {
    report_key: 'InProgressSubscriptionSignups',
    actions: [
      {
        label: 'TABLE_ACTION_BTNS.CREATE_TASK',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.Task,
        icon: 'fa fa-list',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_EMAIL',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendEmail,
        icon: 'fa fa-envelope',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_SMS',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendSms,
        icon: 'fa fa-comments',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_WHATSAPP',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendWhatsApp,
        icon: 'fab fa-whatsapp',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_PUSH_NOTIFICATION',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendPushNotification,
        icon: 'fa fa-bell',
      },
    ],
    columns: [
      {
        title: 'MEMBER NAME',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_full_name',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
      {
        title: 'Plan Name',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'plan_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'plan_name_pri_lang',
            secondary: 'plan_name_sec_lang',
          },
        },
      },
      {
        title: 'Created date',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'subs_sigup_sts_created_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'subs_sigup_sts_created_date',
            format: 'datetime',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Created by ',
        classes: ' py-2  white-space-nowrap',
        dataProperty: 'subs_sigup_sts_created_by',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'subs_sigup_sts_created_by', originalKey: false },
        },
      },
      {
        title: 'Subscription Signup ID',
        classes: 'py-2  white-space-nowrap',
        dataProperty: 'subs_sigup_sts_id',
        type: 'default',
      },
    ],
  },
  {
    report_key: 'ChargesFees',
    actions: [
      {
        label: 'TABLE_ACTION_BTNS.CREATE_TASK',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.Task,
        icon: 'fa fa-list',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_EMAIL',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendEmail,
        icon: 'fa fa-envelope',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_SMS',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendSms,
        icon: 'fa fa-comments',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_WHATSAPP',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendWhatsApp,
        icon: 'fab fa-whatsapp',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_PUSH_NOTIFICATION',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendPushNotification,
        icon: 'fa fa-bell',
      },
    ],
    columns: [
      {
        title: 'MEMBER NAME',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_full_name',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
      {
        title: 'Invoice #',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'inv_number_prefix',
        type: 'default',
      },
      {
        title: 'Invoice Date',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'inv_issue_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'inv_issue_date',
            format: 'datetime',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Charge Name',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_chrg_chrgmst_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'clt_chrg_chrgmst_name_pri_lang',
            secondary: 'clt_chrg_chrgmst_name_sec_lang',
          },
        },
      },
      {
        title: 'Charge Category',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_chrg_category_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'clt_chrg_category_name_pri_lang',
            secondary: 'clt_chrg_category_name_sec_lang',
          },
        },
      },
      {
        title: 'Amount excluding tax',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'invline_total_taxable_cost_in_minor_curr',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'invline_total_taxable_cost_in_minor_curr',
        },
      },
      {
        title: 'Tax Amount',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'invline_total_tax_in_minor_curr',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'invline_total_tax_in_minor_curr',
        },
      },
      {
        title: 'Total Amount',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'invline_total_amt_in_minor_curr',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'invline_total_amt_in_minor_curr',
        },
      },
      {
        title: 'PAYMENT Amount',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'py_inv_link_amount_applied_in_minor_curr',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'py_inv_link_amount_applied_in_minor_curr',
        },
      },
      {
        title: 'Balance Amount',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'invline_total_balance_in_minor_curr',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'invline_total_balance_in_minor_curr',
        },
      },
      {
        title: 'Sales Representative',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_sales_rep',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'inv_sales_rep', originalKey: false },
        },
      },
      {
        title: 'Billed For tenant name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_tenant_for_name_primary_language',
        type: 'default',
      },
      {
        title: 'Billed at tenant name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_tenant_at_name_primary_language',
        type: 'default',
      },
    ],
  },
  {
    report_key: 'FailedSubscriptionSignups',
    actions: [
      {
        label: 'TABLE_ACTION_BTNS.CREATE_TASK',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.Task,
        icon: 'fa fa-list',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_EMAIL',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendEmail,
        icon: 'fa fa-envelope',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_SMS',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendSms,
        icon: 'fa fa-comments',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_WHATSAPP',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendWhatsApp,
        icon: 'fab fa-whatsapp',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_PUSH_NOTIFICATION',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendPushNotification,
        icon: 'fa fa-bell',
      },
    ],
    columns: [
      {
        title: 'Created date',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'subs_sigup_sts_created_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'log_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'MEMBER NAME',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_full_name',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
      {
        title: 'Email Verified',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_is_email_verified',
        type: 'component',
        data: {
          name: YesNoComponent,
          additionData: true,
          aData: { fetch_key: 'clt_is_email_verified', type: 'yes-no' },
        },
      },
      {
        title: 'Plan Name',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'plan_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'plan_name_pri_lang',
            secondary: 'plan_name_sec_lang',
          },
        },
      },
      {
        title: 'Created by ',
        classes: ' py-2  white-space-nowrap',
        dataProperty: 'subs_sigup_sts_created_by',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'subs_sigup_sts_created_by', originalKey: false },
        },
      },
      {
        title: 'Payment Status ',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'pymt_log_external_raw_status',
        type: 'default',
      },
    ],
  },
  {
    report_key: 'CompletedTasksByStaff',
    actions: [],
    columns: [
      {
        title: 'MEMBER NAME',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_id',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
      {
        title: 'Opportunity Stage name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'opp_stage_mst_name_pri_lang',
        type: 'component',
        data: {
          name: OpportunityStageComponent,
          additionData: true,
          aData: {
            primary: 'opp_stage_mst_name_pri_lang',
            secondary: 'opp_stage_mst_name_sec_lang',
          },
        },
      },
      {
        title: 'Staff',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'stf_id',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'stf_id', originalKey: true },
        },
      },
      {
        title: 'Outcome',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'outcome',
        type: 'component',
        data: { name: OutcomeComponent },
      },
      {
        title: 'Task ID',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'task_id',
        type: 'default',
      },
      {
        title: 'Task Type',
        classes: 'py-2  white-space-nowrap',
        dataProperty: 'tsk_type',
        type: 'component',
        data: { name: TaskTypeReportComponent },
      },
      {
        title: 'Task Category',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'tsk_categoryid',
        type: 'component',
        data: { name: TaskCategoryCellComponent },
      },
      {
        title: 'Task Reschedule Count',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'tsk_reschedule_count',
        type: 'default',
      },
      {
        title: 'Notes',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'notes',
        type: 'default',
      },
      {
        title: 'Log Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'log_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'log_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Email Verified',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_is_email_verified',
        type: 'component',
        data: {
          name: YesNoComponent,
          additionData: true,
          aData: { fetch_key: 'clt_is_email_verified', type: 'yes-no' },
        },
      },
      {
        title: 'Opportunity ID',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'tsk_opp_id',
        type: 'default',
      },
    ],
  },
  {
    report_key: 'SubscriptionNotRenewing',
    actions: [
      {
        label: 'TABLE_ACTION_BTNS.CREATE_TASK',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.Task,
        icon: 'fa fa-list',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_EMAIL',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendEmail,
        icon: 'fa fa-envelope',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_SMS',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendSms,
        icon: 'fa fa-comments',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_WHATSAPP',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendWhatsApp,
        icon: 'fab fa-whatsapp',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_PUSH_NOTIFICATION',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendPushNotification,
        icon: 'fa fa-bell',
      },
    ],
    columns: [
      {
        title: 'MEMBER NAME',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_id',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
      {
        title: 'Subscription Id',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_id',
        type: 'default',
      },
      {
        title: 'Subscription Name',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_subs_name_pri_lang',
        type: 'default',
      },
      {
        title: 'Subscription Category',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_category',
        type: 'component',
        data: { name: SubscriptionCategoryDisplayComponent },
      },
      {
        title: 'Scheduled Start Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_start_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'clt_subs_start_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Scheduled End Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_end_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'clt_subs_end_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Subscription Status',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_status',
        type: 'component',
        data: { name: SubscriptionStatusComponent },
      },
      {
        title: 'Scheduled Cancel Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_cancel_scheduled_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'clt_subs_cancel_scheduled_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Recurring Revenue',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_recurring_revenue',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'clt_subs_recurring_revenue',
        },
      },
      {
        title: 'Autopay Enabled',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_is_autopay_enabled',
        type: 'component',
        data: {
          name: YesNoComponent,
          additionData: true,
          aData: { fetch_key: 'clt_subs_is_autopay_enabled', type: 'yes-no' },
        },
      },
      {
        title: 'Sales Representative',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_sales_rep',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'clt_subs_sales_rep', originalKey: false },
        },
      },
      {
        title: 'CREATED BY	',
        classes: 'py-2  white-space-nowrap',
        dataProperty: 'clt_subs_created_by',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'clt_subs_created_by', originalKey: false },
        },
      },
      {
        title: 'CREATED DATE',
        classes: 'py-2  white-space-nowrap',
        dataProperty: 'clt_subs_created_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'clt_subs_created_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
    ],
  },
  {
    report_key: 'SubscriptionExpired',
    actions: [
      {
        label: 'TABLE_ACTION_BTNS.CREATE_TASK',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.Task,
        icon: 'fa fa-list',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_EMAIL',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendEmail,
        icon: 'fa fa-envelope',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_SMS',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendSms,
        icon: 'fa fa-comments',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_WHATSAPP',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendWhatsApp,
        icon: 'fab fa-whatsapp',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_PUSH_NOTIFICATION',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendPushNotification,
        icon: 'fa fa-bell',
      },
    ],
    columns: [
      {
        title: 'Member Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_full_name',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
      {
        title: 'Start Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_start_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'clt_subs_start_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'End Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_end_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'clt_subs_end_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Subscription',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'clt_subs_name_pri_lang',
            secondary: 'clt_subs_name_sec_lang',
          },
        },
      },
      {
        title: 'Subscription Status',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_status',
        type: 'component',
        data: { name: SubscriptionStatusComponent },
      },
      {
        title: 'Subscription Category',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_category',
        type: 'component',
        data: { name: SubscriptionCategoryDisplayComponent },
      },
      {
        title: 'Autopay',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_is_autopay_enabled',
        type: 'component',
        data: {
          name: YesNoComponent,
          additionData: true,
          aData: { fetch_key: 'clt_subs_is_autopay_enabled', type: 'yes-no' },
        },
      },
      {
        title: 'Subscription Revenue',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_recurring_revenue',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'clt_subs_recurring_revenue',
        },
      },
    ],
  },
  {
    report_key: 'ChurnClient',
    actions: [
      {
        label: 'TABLE_ACTION_BTNS.CREATE_TASK',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.Task,
        icon: 'fa fa-list',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_EMAIL',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendEmail,
        icon: 'fa fa-envelope',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_SMS',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendSms,
        icon: 'fa fa-comments',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_WHATSAPP',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendWhatsApp,
        icon: 'fab fa-whatsapp',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_PUSH_NOTIFICATION',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendPushNotification,
        icon: 'fa fa-bell',
      },
    ],
    columns: [
      {
        title: 'Churn Date',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_churn_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'clt_churn_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Subscription End Date',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_subs_end_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'clt_churn_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Subscription status',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_subs_status',
        type: 'component',
        data: { name: SubscriptionStatusComponent },
      },
      {
        title: 'MEMBER NAME',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_full_name',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },

      {
        title: 'Subscription Category',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_subs_category',
        type: 'component',
        data: { name: SubscriptionCategoryDisplayComponent },
      },

      {
        title: 'Subscription name',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_subs_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'clt_subs_name_pri_lang',
            secondary: 'clt_subs_name_sec_lang',
          },
        },
      },
    ],
  },
  {
    report_key: 'SubscriptionDetailReport',
    actions: [
      {
        label: 'TABLE_ACTION_BTNS.CREATE_TASK',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.Task,
        icon: 'fa fa-list',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_EMAIL',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendEmail,
        icon: 'fa fa-envelope',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_SMS',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendSms,
        icon: 'fa fa-comments',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_WHATSAPP',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendWhatsApp,
        icon: 'fab fa-whatsapp',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_PUSH_NOTIFICATION',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendPushNotification,
        icon: 'fa fa-bell',
      },
    ],
    columns: [
      {
        title: 'MEMBER NAME',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_full_name',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
      {
        title: 'Subscription Id',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_id',
        type: 'default',
      },
      {
        title: 'Subscription name',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_subs_name_pri_lang',
        type: 'default',
      },
      {
        title: 'Subscription Type',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_type',
        type: 'component',
        data: { name: SubscriptionCategoryDisplayComponent },
      },
      {
        title: 'Status',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_status',
        type: 'component',
        data: { name: SubscriptionStatusComponent },
      },
      {
        title: 'Signup Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_signup_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'clt_subs_signup_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Start date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_start_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'clt_subs_start_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'End date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_end_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'clt_subs_end_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Sales Representative',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_sales_rep',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'clt_subs_sales_rep', originalKey: false },
        },
      },
      {
        title: 'Payment Method',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_pay_token_paymode_level1',
        type: 'component',
        data: {
          name: PaymentModeComponent,
          additionData: true,
          aData: { fetch_key: 'clt_pay_token_paymode_level1' },
        },
      },
      {
        title: 'Payment method details',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_pay_token_masked_card_number',
        type: 'component',
        data: { name: PaymentDetailsReportComponent },
      },
      {
        title: 'Next billing date ',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_next_charge_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'clt_subs_next_charge_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'ContrAct Term',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_contract_term',
        type: 'component',
        data: { name: ContractTermViewComponent },
      },

      {
        title: 'Automatic payment',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_is_autopay_enabled',
        type: 'component',
        data: {
          name: YesNoComponent,
          additionData: true,
          aData: { fetch_key: 'clt_subs_is_autopay_enabled', type: 'yes-no' },
        },
      },
      {
        title: 'Transferable',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_transferable',
        type: 'component',
        data: {
          name: YesNoComponent,
          additionData: true,
          aData: { fetch_key: 'clt_subs_transferable', type: 'yes-no' },
        },
      },
      {
        title: 'Cancellation date ',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_cancelled_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'clt_subs_cancelled_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Scheduled cancellation date',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_subs_cancel_scheduled_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'clt_subs_cancel_scheduled_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Suspended date',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_subs_suspended_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'clt_subs_suspended_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Billing cycle',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_subs_billing_interval_type',
        // type: 'default',
        type: 'component',
        data: { name: BillingCycleComponent },
      },
      {
        title: 'CREATED BY	',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_subs_created_by',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'clt_subs_created_by', originalKey: false },
        },
      },
      {
        title: 'CREATED DATE',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_subs_created_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'clt_subs_created_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
    ],
  },
  {
    report_key: 'SubscriptionSignUpReport',
    actions: [
      {
        label: 'TABLE_ACTION_BTNS.CREATE_TASK',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.Task,
        icon: 'fa fa-list',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_EMAIL',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendEmail,
        icon: 'fa fa-envelope',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_SMS',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendSms,
        icon: 'fa fa-comments',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_WHATSAPP',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendWhatsApp,
        icon: 'fab fa-whatsapp',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_PUSH_NOTIFICATION',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendPushNotification,
        icon: 'fa fa-bell',
      },
    ],
    columns: [
      {
        title: 'MEMBER NAME',
        classes: 'py-2  white-space-nowrap',
        dataProperty: 'clt_full_name',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
      {
        title: 'Subscription name',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'plan_name_pri_lang',
        type: 'default',
      },
      {
        title: 'UUID',
        classes: ' py-2  white-space-nowrap',
        dataProperty: 'cpcl_uuid',
        type: 'default',
      },
      {
        title: 'Track Mode',
        classes: ' py-2  white-space-nowrap',
        dataProperty: 'subs_sigup_sts_track_mode',
        type: 'component',
        data: {
          name: TrackModeComponent,
          additionData: true,
          aData: { fetch_key: 'subs_sigup_sts_track_mode' },
        },
      },
      {
        title: 'CREATED BY	',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'subs_sigup_sts_created_by',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'subs_sigup_sts_created_by', originalKey: false },
        },
      },
      {
        title: 'CREATED DATE',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'subs_sigup_sts_created_date',
        type: 'component',
        data: {
          name: DateCellComponent,
          additionData: true,
          aData: {
            fetch_key: 'subs_sigup_sts_created_date',
            applytimezone: false,
          },
        },
      },
      {
        title: 'LAST UPDATED BY	',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'subs_sigup_sts_updated_by',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'subs_sigup_sts_updated_by', originalKey: false },
        },
      },
      {
        title: 'LAST UPDATED ON',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'subs_sigup_sts_updated_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'subs_sigup_sts_updated_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
    ],
  },
  {
    report_key: 'WonBackClient',
    actions: [
      {
        label: 'TABLE_ACTION_BTNS.CREATE_TASK',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.Task,
        icon: 'fa fa-list',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_EMAIL',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendEmail,
        icon: 'fa fa-envelope',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_SMS',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendSms,
        icon: 'fa fa-comments',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_WHATSAPP',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendWhatsApp,
        icon: 'fab fa-whatsapp',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_PUSH_NOTIFICATION',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendPushNotification,
        icon: 'fa fa-bell',
      },
    ],
    columns: [
      {
        title: 'Won Back Date',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_won_back_date',
        type: 'default',
      },
      {
        title: 'MEMBER NAME',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_full_name',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
    ],
  },
  {
    report_key: 'AppointmentByCoach',
    actions: [],
    columns: [
      {
        title: 'Appointment name',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'appt_type_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'appt_type_name_pri_lang',
            secondary: 'appt_type_name_sec_lang',
            color: 'appt_type_color',
          },
        },
      },
      {
        title: 'Appointment sub type',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'appt_subtype_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'appt_subtype_name_pri_lang',
            secondary: 'appt_subtype_name_sec_lang',
            color: 'appt_type_color',
          },
        },
      },
      {
        title: 'Coach',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'appt_coach_id',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'appt_coach', originalKey: false },
        },
      },
      {
        title: 'Appointment start Date',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'appt_start_datetime',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'appt_start_datetime',
            format: 'datetime',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Appointment end Date',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'appt_end_datetime',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'appt_end_datetime',
            format: 'datetime',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Appointment behavior',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'appt_type_behaviour',
        type: 'component',
        data: { name: BehaviourViewComponent },
      },
      {
        title: 'Appointment status',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'appt_status',
        type: 'component',
        data: { name: AppointmentStatusComponent },
      },
      {
        title: 'Room Name',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'appt_room_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'appt_room_name_pri_lang',
            secondary: 'appt_room_name_pri_lang',
          },
        },
      },
      {
        title: 'First Appointment ',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'appt_is_first_time_appt',
        type: 'component',
        data: {
          name: YesNoComponent,
          additionData: true,
          aData: { fetch_key: 'appt_is_first_time_appt', type: 'yes-no' },
        },
      },
      {
        title: 'Is Virtual ',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'appt_is_virtual',
        type: 'component',
        data: {
          name: YesNoComponent,
          additionData: true,
          aData: { fetch_key: 'appt_is_virtual', type: 'yes-no' },
        },
      },
      {
        title: 'Comp Session',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'appt_is_comp_session',
        type: 'component',
        data: {
          name: YesNoComponent,
          additionData: true,
          aData: { fetch_key: 'appt_is_comp_session', type: 'yes-no' },
        },
      },
      {
        title: 'MEMBER NAME',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_id',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
      {
        title: 'Subscription Id',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'appt_clt_subscription_id',
        type: 'default',
      },
      {
        title: 'Subscription Name',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_subs_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'clt_subs_name_pri_lang',
            secondary: 'clt_subs_name_sec_lang',
          },
        },
      },
      {
        title: 'Service Category Name',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_mbrshp_service_category_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'clt_mbrshp_service_category_name_pri_lang',
            secondary: 'clt_mbrshp_service_category_name_sec_lang',
          },
        },
      },
      {
        title: 'membership Id',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'appt_clt_mbrshp_id',
        type: 'default',
      },

      {
        title: 'Sessions Revenue ',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'appt_session_revenue',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'appt_session_revenue',
        },
      },
    ],
  },
  {
    report_key: 'AppointmentByCategory',
    actions: [
      {
        label: 'TABLE_ACTION_BTNS.CREATE_TASK',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.Task,
        icon: 'fa fa-list',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_EMAIL',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendEmail,
        icon: 'fa fa-envelope',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_SMS',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendSms,
        icon: 'fa fa-comments',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_WHATSAPP',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendWhatsApp,
        icon: 'fab fa-whatsapp',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_PUSH_NOTIFICATION',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendPushNotification,
        icon: 'fa fa-bell',
      },
    ],
    columns: [
      {
        title: 'MEMBER NAME',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_id',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
      {
        title: 'Appointment name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'appt_type_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'appt_type_name_pri_lang',
            secondary: 'appt_type_name_sec_lang',
            color: 'appt_type_color',
          },
        },
      },
      {
        title: 'Appointment sub type',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'appt_subtype_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'appt_subtype_name_pri_lang',
            secondary: 'appt_subtype_name_sec_lang',
            color: 'appt_type_color',
          },
        },
      },
      {
        title: 'Appointment behavior',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'appt_type_behaviour',
        type: 'component',
        data: { name: BehaviourViewComponent },
      },
      {
        title: 'Service Category',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_mbrshp_service_category_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'clt_mbrshp_service_category_name_pri_lang',
            secondary: 'clt_mbrshp_service_category_name_sec_lang',
          },
        },
      },
      {
        title: 'Subscription Name',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_subs_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'clt_subs_name_pri_lang',
            secondary: 'clt_subs_name_sec_lang',
          },
        },
      },
      {
        title: 'Appointment start Date',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'appt_start_datetime',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'appt_start_datetime',
            format: 'datetime',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Appointment end Date',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'appt_end_datetime',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'appt_end_datetime',
            format: 'datetime',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Appointment With',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'appt_coach_id',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'appt_coach', originalKey: false },
        },
      },
      {
        title: 'Appointment status',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'appt_status',
        type: 'component',
        data: { name: AppointmentStatusComponent },
      },

      {
        title: 'Room',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'appt_room_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'appt_room_name_pri_lang',
            secondary: 'appt_room_name_sec_lang',
          },
        },
      },
      {
        title: 'Is Virtual ',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'appt_is_virtual',
        type: 'component',
        data: {
          name: YesNoComponent,
          additionData: true,
          aData: { fetch_key: 'appt_is_virtual', type: 'yes-no' },
        },
      },
      {
        title: 'First Appointment ',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'appt_is_first_time_appt',
        type: 'component',
        data: {
          name: YesNoComponent,
          additionData: true,
          aData: { fetch_key: 'appt_is_first_time_appt', type: 'yes-no' },
        },
      },
      {
        title: 'Comp session',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'appt_is_comp_session',
        type: 'default',
      },

      {
        title: 'Sessions Revenue ',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'appt_session_revenue',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'appt_session_revenue',
        },
      },
    ],
  },
  {
    report_key: 'CancelledAppointmentByCategory',
    actions: [
      {
        label: 'TABLE_ACTION_BTNS.CREATE_TASK',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.Task,
        icon: 'fa fa-list',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_EMAIL',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendEmail,
        icon: 'fa fa-envelope',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_SMS',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendSms,
        icon: 'fa fa-comments',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_WHATSAPP',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendWhatsApp,
        icon: 'fab fa-whatsapp',
      },
    ],
    columns: [
      {
        title: 'Appointment name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'appt_type_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'appt_type_name_pri_lang',
            secondary: 'appt_type_name_sec_lang',
            color: 'appt_type_color',
          },
        },
      },
      {
        title: 'Appointment sub type',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'appt_subtype_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'appt_subtype_name_pri_lang',
            secondary: 'appt_subtype_name_sec_lang',
            color: 'appt_type_color',
          },
        },
      },
      {
        title: 'Appointment behavior',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'appt_type_behaviour',
        type: 'component',
        data: { name: BehaviourViewComponent },
      },
      {
        title: 'Appointment start Date',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'appt_start_datetime',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'appt_start_datetime',
            format: 'datetime',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Appointment end Date',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'appt_end_datetime',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'appt_end_datetime',
            format: 'datetime',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Room Name',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'appt_room_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'appt_room_name_pri_lang',
            secondary: 'appt_room_name_pri_lang',
          },
        },
      },
      {
        title: 'Appointment status',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'appt_status',
        type: 'component',
        data: { name: AppointmentStatusComponent },
      },
      {
        title: 'cancellation Reason ',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'appt_cancellation_reason',
        type: 'default',
      },
      {
        title: 'Coach',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'appt_coach_id',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'appt_coach', originalKey: false },
        },
      },
      {
        title: 'First Appointment ',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'appt_is_first_time_appt',
        type: 'component',
        data: {
          name: YesNoComponent,
          additionData: true,
          aData: { fetch_key: 'appt_is_first_time_appt', type: 'yes-no' },
        },
      },
      {
        title: 'Comp Session',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'appt_is_comp_session',
        type: 'component',
        data: {
          name: YesNoComponent,
          additionData: true,
          aData: { fetch_key: 'appt_is_comp_session', type: 'yes-no' },
        },
      },
      {
        title: 'Comp Id',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'appt_is_comp_session',
        type: 'default',
      },
      {
        title: 'Is Late Cancel',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'appt_is_late_cancel',
        type: 'component',
        data: {
          name: YesNoComponent,
          additionData: true,
          aData: { fetch_key: 'appt_is_late_cancel', type: 'yes-no' },
        },
      },
      {
        title: 'Is Virtual ',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'appt_is_virtual',
        type: 'component',
        data: {
          name: YesNoComponent,
          additionData: true,
          aData: { fetch_key: 'appt_is_virtual', type: 'yes-no' },
        },
      },
      {
        title: 'MEMBER NAME',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_id',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
      {
        title: 'Subscription Id',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'appt_clt_subscription_id',
        type: 'default',
      },
      {
        title: 'Subscription Name',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_subs_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'clt_subs_name_pri_lang',
            secondary: 'clt_subs_name_sec_lang',
          },
        },
      },
      {
        title: 'Service Category Name',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_mbrshp_service_category_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'clt_mbrshp_service_category_name_pri_lang',
            secondary: 'clt_mbrshp_service_category_name_sec_lang',
          },
        },
      },
      {
        title: 'membership Id',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'appt_clt_mbrshp_id',
        type: 'default',
      },

      {
        title: 'Sessions Revenue ',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'appt_session_revenue',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'appt_session_revenue',
        },
      },
    ],
  },
  {
    report_key: 'ClientCheckIns',
    actions: [
      {
        label: 'TABLE_ACTION_BTNS.CREATE_TASK',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.Task,
        icon: 'fa fa-list',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_EMAIL',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendEmail,
        icon: 'fa fa-envelope',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_SMS',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendSms,
        icon: 'fa fa-comments',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_WHATSAPP',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendWhatsApp,
        icon: 'fab fa-whatsapp',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_PUSH_NOTIFICATION',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendPushNotification,
        icon: 'fa fa-bell',
      },
    ],
    columns: [
      {
        title: 'Checkin Time',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_chkin_date_time',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'clt_chkin_date_time',
            format: 'datetime',
            applytimezone: false,
          },
        },
      },
      {
        title: 'MEMBER NAME',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_id',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
      {
        title: 'Checkin / Checkout',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_chkin_event_type',
        type: 'component',
        data: {
          name: CheckInEventComponent,
          additionData: true,
          aData: { fetch_key: 'clt_chkin_event_type', type: 'checkIn' },
        },
      },
      {
        title: 'status',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_chkin_access_status',
        type: 'component',
        data: {
          name: CheckInStatusComponent,
          additionData: true,
          aData: { fetch_key: 'clt_chkin_access_status' },
        },
      },
      {
        title: 'Class Type',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'class_type_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'class_type_name_pri_lang',
            secondary: 'class_type_name_sec_lang',
          },
        },
      },
      {
        title: 'Appointment Type',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'appt_type_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'appt_type_name_pri_lang',
            secondary: 'appt_type_name_sec_lang',
          },
        },
      },
      {
        title: 'Membership Service',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_mbrshp_service_category_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'clt_mbrshp_service_category_name_pri_lang',
            secondary: 'clt_mbrshp_service_category_name_sec_lang',
          },
        },
      },
      {
        title: 'Access status Reason',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_chkin_access_status_reason',
        type: 'default',
      },
      {
        title: 'Home Center',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'home_club_primary_name',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'home_club_primary_name',
            secondary: 'home_club_secondary_name',
          },
        },
      },
    ],
  },
  {
    report_key: 'NewJoinerClient',
    actions: [
      {
        label: 'TABLE_ACTION_BTNS.CREATE_TASK',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.Task,
        icon: 'fa fa-list',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_EMAIL',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendEmail,
        icon: 'fa fa-envelope',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_SMS',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendSms,
        icon: 'fa fa-comments',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_WHATSAPP',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendWhatsApp,
        icon: 'fab fa-whatsapp',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_PUSH_NOTIFICATION',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendPushNotification,
        icon: 'fa fa-bell',
      },
    ],
    columns: [
      {
        title: 'MEMBER NAME',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_id',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
      {
        title: 'Joining Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_since',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'clt_since',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Home Club',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'tent_name_pri_lang',
        type: 'default',
      },
      {
        title: 'Subscription Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'clt_subs_name_pri_lang',
            secondary: 'clt_subs_name_sec_lang',
          },
        },
      },

      {
        title: 'Subcription type',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_type',
        type: 'component',
        data: { name: SubscriptionCategoryDisplayComponent },
      },

      {
        title: 'Waiver Status',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_is_waiver',
        type: 'component',
        data: {
          name: YesNoComponent,
          additionData: true,
          aData: { fetch_key: 'clt_is_waiver', type: 'yes-no' },
        },
      },
      {
        title: 'Autopay',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_is_autopay_enabled',
        type: 'component',
        data: {
          name: YesNoComponent,
          additionData: true,
          aData: { fetch_key: 'clt_subs_is_autopay_enabled', type: 'yes-no' },
        },
      },
      {
        title: 'Subscription End Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_end_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'clt_subs_end_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Sales Representative',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_sales_rep',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'inv_sales_rep', originalKey: false },
        },
      },
      {
        title: 'Signed up via',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_trackmode',
        type: 'component',
        data: {
          name: TrackModeComponent,
          additionData: true,
          aData: { fetch_key: 'clt_subs_trackmode' },
        },
      },
    ],
  },
  {
    report_key: 'InvoiceSummary',
    actions: [
      {
        label: 'TABLE_ACTION_BTNS.CREATE_TASK',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.Task,
        icon: 'fa fa-list',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_EMAIL',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendEmail,
        icon: 'fa fa-envelope',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_SMS',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendSms,
        icon: 'fa fa-comments',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_WHATSAPP',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendWhatsApp,
        icon: 'fab fa-whatsapp',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_PUSH_NOTIFICATION',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendPushNotification,
        icon: 'fa fa-bell',
      },
    ],
    columns: [
      {
        title: 'MEMBER NAME',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_full_name',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
      {
        title: 'Invoice Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_issue_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'inv_issue_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Invoice Billing Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_billing_name',
        type: 'default',
      },
      {
        title: 'Invoice #',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'inv_number_prefix',
        type: 'default',
      },
      {
        title: 'Invoice Amt',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_total_amt_in_minor_curr',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'inv_total_amt_in_minor_curr',
        },
      },
      {
        title: 'Balance Amt',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_total_balance_due_in_minor_curr',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'inv_total_balance_due_in_minor_curr',
        },
      },
      {
        title: 'Tax Amt',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_total_tax_amt_in_minor_curr',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'inv_total_tax_amt_in_minor_curr',
        },
      },
      {
        title: 'Amount without Tax',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_total_base_amt_in_minor_curr',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'inv_total_base_amt_in_minor_curr',
        },
      },
      {
        title: 'paid Amount',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_total_payment_in_minor_curr',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'inv_total_payment_in_minor_curr',
        },
      },
      {
        title: 'Invoice Status',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'status',
        type: 'component',
        data: {
          name: InvoiceStatusComponent,
          additionData: true,
          aData: { fetch_key: 'status' },
        },
      },
      {
        title: 'Void Invoice Reason',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_void_reason',
        type: 'default',
      },
      {
        title: 'Member Since Date',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_since',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'clt_since',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Sales Representative',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_sales_rep',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'inv_sales_rep', originalKey: false },
        },
      },
      {
        title: 'Created by ',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_created_by',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'inv_created_by', originalKey: false },
        },
      },
      {
        title: 'Created date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_created_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'inv_created_date',
            format: 'datetime',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Last Updated by ',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_updated_by',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'inv_updated_by', originalKey: false },
        },
      },
      {
        title: 'Last Updated date',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'inv_updated_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'inv_updated_date',
            format: 'datetime',
            applytimezone: false,
          },
        },
      },
    ],
  },
  {
    report_key: 'ClassAttendance',
    actions: [
      {
        label: 'TABLE_ACTION_BTNS.CREATE_TASK',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.Task,
        icon: 'fa fa-list',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_EMAIL',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendEmail,
        icon: 'fa fa-envelope',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_SMS',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendSms,
        icon: 'fa fa-comments',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_WHATSAPP',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendWhatsApp,
        icon: 'fab fa-whatsapp',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_PUSH_NOTIFICATION',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendPushNotification,
        icon: 'fa fa-bell',
      },
    ],
    columns: [
      {
        title: 'Class Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'class_type_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'class_type_name_pri_lang',
            secondary: 'class_type_name_sec_lang',
            color: 'class_type_color',
          },
        },
      },
      {
        title: 'Class Subtype Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'class_subtype_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'class_subtype_name_pri_lang',
            secondary: 'class_subtype_name_sec_lang',
            color: 'class_type_color',
          },
        },
      },
      {
        title: 'Class Start Date',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'class_booking_class_start_datetime',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'class_booking_class_start_datetime',
            format: 'datetime',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Class End Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'class_booking_class_end_datetime',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'class_booking_class_end_datetime',
            format: 'datetime',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Class Behaviour',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'class_type_behaviour',
        type: 'component',
        data: { name: BehaviourViewComponent },
      },
      {
        title: 'Service Category Name',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_mbrshp_service_category_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'clt_mbrshp_service_category_name_pri_lang',
            secondary: 'clt_mbrshp_service_category_name_sec_lang',
          },
        },
      },
      {
        title: 'Coach',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'class_coach_id',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'class_coach', originalKey: false },
        },
      },
      {
        title: 'MEMBER NAME',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_full_name',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
      {
        title: 'Subscription Name',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_subs_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'clt_subs_name_pri_lang',
            secondary: 'clt_subs_name_sec_lang',
          },
        },
      },
      {
        title: 'First Time booked',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'class_booking_is_first_time_class',
        type: 'component',
        data: {
          name: YesNoComponent,
          additionData: true,
          aData: {
            fetch_key: 'class_booking_is_first_time_class',
            type: 'yes-no',
          },
        },
      },
      {
        title: 'Class Pass',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'class_booking_cp_booking',
        type: 'component',
        data: { name: ClassPassComponent },
      },
      {
        title: 'Booking Status',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'class_booking_status',
        type: 'component',
        data: { name: ClassBookingStatusComponent },
      },
      {
        title: 'Comp Session',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'class_booking_is_comp_session',
        type: 'component',
        data: {
          name: YesNoComponent,
          additionData: true,
          aData: { fetch_key: 'class_booking_is_comp_session', type: 'yes-no' },
        },
      },
      {
        title: 'Sessions Revenue ',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'class_booking_session_revenue',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'class_booking_session_revenue',
        },
      },
      {
        title:'Rating',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'class_booking_rating',
        type: 'default',
      },
      {
        title:'Comments',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'class_booking_rating_comments',
        type: 'default',
      },
      {
        title: 'Total Exemptions',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_noshow_late_cancel_limit_per_year',
        type: 'default',
      },
      
    ],
  },
  {
    report_key: 'ClassSummary',
    actions: [],
    columns: [
      {
        title: 'Class Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'class_type_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'class_type_name_pri_lang',
            secondary: 'class_type_name_sec_lang',
            color: 'class_type_color',
          },
        },
      },
      {
        title: 'Class Subtype Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'class_subtype_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'class_subtype_name_pri_lang',
            secondary: 'class_subtype_name_sec_lang',
            color: 'class_type_color',
          },
        },
      },
      {
        title: 'Class Start Date',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'class_start_datetime',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'class_start_datetime',
            format: 'datetime',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Class End Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'class_end_datetime',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'class_end_datetime',
            format: 'datetime',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Class Behaviour',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'class_behaviour',
        type: 'component',
        data: { name: BehaviourViewComponent },
      },
      {
        title: 'Coach',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'class_coach_id',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'class_coach', originalKey: false },
        },
      },
      {
        title: 'Class Status',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'class_status',
        type: 'component',
        data: { name: ClassStatusComponent },
      },
      {
        title: 'Class Capacity',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'class_max_capacity',
        type: 'default',
      },
      {
        title: 'Total Booked',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'total_booked',
        type: 'default',
      },
      {
        title: 'Total Attended',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'total_attended',
        type: 'default',
      },
      {
        title: 'Total No Shows',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'total_no_shows',
        type: 'default',
      },
      {
        title: 'Total Cancelled',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'total_cancelled',
        type: 'default',
      },
      {
        title: 'Class Utilization',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'class_utilization',
        type: 'component',
        data: { name: ClassUtilizationComponent },
      },
      {
        title: 'Total Paid Clients',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'total_paid_clients',
        type: 'default',
      },
      {
        title: 'Trial Clients',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'trial_clients',
        type: 'default',
      },
      {
        title: 'Total Comp Clients',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'total_comp_clients',
        type: 'default',
      },
      {
        title: 'Class Revenue',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'class_revenue',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'class_revenue',
        },
      },
    ],
  },
  {
    report_key: 'SalesByServiceCategory',
    actions: [
      {
        label: 'TABLE_ACTION_BTNS.CREATE_TASK',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.Task,
        icon: 'fa fa-list',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_EMAIL',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendEmail,
        icon: 'fa fa-envelope',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_SMS',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendSms,
        icon: 'fa fa-comments',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_WHATSAPP',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendWhatsApp,
        icon: 'fab fa-whatsapp',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_PUSH_NOTIFICATION',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendPushNotification,
        icon: 'fa fa-bell',
      },
    ],
    columns: [
      {
        title: 'MEMBER NAME',
        classes: 'py-2  white-space-nowrap',
        dataProperty: 'clt_id',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
      {
        title: 'Invoice #',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'inv_number_prefix',
        type: 'default',
      },
      {
        title: 'Service Category Name',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_mbrshp_service_category_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'clt_mbrshp_service_category_name_pri_lang',
            secondary: 'clt_mbrshp_service_category_name_sec_lang',
          },
        },
      },
      {
        title: 'Subscription Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'clt_subs_name_pri_lang',
            secondary: 'clt_subs_name_sec_lang',
          },
        },
      },
      {
        title: 'Offer Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_offer_mst_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'inv_offer_mst_name_pri_lang',
            secondary: 'inv_offer_mst_name_sec_lang',
          },
        },
      },
      {
        title: 'Service Validity',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_mbrshp_no_of_days',
        type: 'component',
        data: {
          name: ServiceValidityComponent,
          additionData: true,
          aData: { fetch_key: 'clt_mbrshp_no_of_days' },
        },
      },
      {
        title: 'Session Count',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_mbrshp_no_of_session',
        type: 'default',
      },
      {
        title: 'Purchase Date',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'inv_issue_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'inv_issue_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Start Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_mbrshp_start_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'clt_mbrshp_start_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'End Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_mbrshp_end_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'clt_mbrshp_end_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Amount excluding tax',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'invline_total_taxable_cost_in_minor_curr',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'invline_total_taxable_cost_in_minor_curr',
        },
      },
      {
        title: 'Tax Amount',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'invline_total_tax_in_minor_curr',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'invline_total_tax_in_minor_curr',
        },
      },
      {
        title: 'Total Amount',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'invline_total_amt_in_minor_curr',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'invline_total_amt_in_minor_curr',
        },
      },
      {
        title: 'PAYMENT Amount',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'py_inv_link_amount_applied_in_minor_curr',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'py_inv_link_amount_applied_in_minor_curr',
        },
      },
      {
        title: 'Balance Amount',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'invline_total_balance_in_minor_curr',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'invline_total_balance_in_minor_curr',
        },
      },
      {
        title: 'Created by ',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_created_by',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'inv_created_by', originalKey: false },
        },
      },
      {
        title: 'Sales Representative',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_sales_rep',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'inv_sales_rep', originalKey: false },
        },
      },
      {
        title: 'Billed For tenant name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_tenant_for_name_primary_language',
        type: 'default',
      },
      {
        title: 'Billed at tenant name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_tenant_at_name_primary_language',
        type: 'default',
      },
    ],
  },
  {
    report_key: 'InvoiceDetail',
    actions: [
      {
        label: 'TABLE_ACTION_BTNS.CREATE_TASK',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.Task,
        icon: 'fa fa-list',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_EMAIL',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendEmail,
        icon: 'fa fa-envelope',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_SMS',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendSms,
        icon: 'fa fa-comments',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_WHATSAPP',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendWhatsApp,
        icon: 'fab fa-whatsapp',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_PUSH_NOTIFICATION',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendPushNotification,
        icon: 'fa fa-bell',
      },
    ],
    columns: [
      {
        title: 'MEMBER NAME',
        classes: 'py-2  white-space-nowrap',
        dataProperty: 'clt_id',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
      {
        title: 'Invoice #',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'inv_number_prefix',
        type: 'default',
      },
      {
        title: 'Subscription Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'clt_subs_name_pri_lang',
            secondary: 'clt_subs_name_sec_lang',
          },
        },
      },
      {
        title: 'Service Category Name',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_mbrshp_service_category_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'clt_mbrshp_service_category_name_pri_lang',
            secondary: 'clt_mbrshp_service_category_name_sec_lang',
          },
        },
      },
      {
        title: 'Charge Category Name',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_chrg_category_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'clt_chrg_category_name_pri_lang',
            secondary: 'clt_chrg_category_name_pri_lang',
          },
        },
      },
      {
        title: 'Purchase Date',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'inv_issue_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'inv_issue_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Start Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_mbrshp_start_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'clt_mbrshp_start_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'End Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_mbrshp_end_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'clt_mbrshp_end_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Amount excluding tax',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'invline_total_taxable_cost_in_minor_curr',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'invline_total_taxable_cost_in_minor_curr',
        },
      },
      {
        title: 'Tax Amount',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'invline_total_tax_in_minor_curr',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'invline_total_tax_in_minor_curr',
        },
      },
      {
        title: 'Total Amount',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'invline_total_amt_in_minor_curr',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'invline_total_amt_in_minor_curr',
        },
      },
      {
        title: 'PAYMENT Amount',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'py_inv_link_amount_applied_in_minor_curr',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'py_inv_link_amount_applied_in_minor_curr',
        },
      },
      {
        title: 'BALANCE Amount',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'invline_total_balance_in_minor_curr',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'invline_total_balance_in_minor_curr',
        },
      },
      {
        title: 'Created by ',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_created_by',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'inv_created_by', originalKey: false },
        },
      },
      {
        title: 'Sales Representative',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_sales_rep',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'inv_sales_rep', originalKey: false },
        },
      },
      {
        title: 'Billed For tenant name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_tenant_for_name_primary_language',
        type: 'default',
      },
      {
        title: 'Billed at tenant name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_tenant_at_name_primary_language',
        type: 'default',
      },
    ],
  },
  {
    report_key: 'ARAgingSummaryByClient',
    actions: [
      {
        label: 'TABLE_ACTION_BTNS.CREATE_TASK',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.Task,
        icon: 'fa fa-list',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_EMAIL',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendEmail,
        icon: 'fa fa-envelope',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_SMS',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendSms,
        icon: 'fa fa-comments',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_WHATSAPP',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendWhatsApp,
        icon: 'fab fa-whatsapp',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_PUSH_NOTIFICATION',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendPushNotification,
        icon: 'fa fa-bell',
      },
    ],
    columns: [
      {
        title: 'MEMBER NAME',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_id',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
      {
        title: 'Client Representative',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_rep_id',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'clt_rep', originalKey: false },
        },
      },
      {
        title: 'CURRENT BALANCE',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_outstanding_due',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'clt_outstanding_due',
        },
      },
    ],
  },
  {
    report_key: 'ARAgingDetailReport',
    actions: [
      {
        label: 'TABLE_ACTION_BTNS.CREATE_TASK',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.Task,
        icon: 'fa fa-list',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_EMAIL',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendEmail,
        icon: 'fa fa-envelope',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_SMS',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendSms,
        icon: 'fa fa-comments',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_WHATSAPP',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendWhatsApp,
        icon: 'fab fa-whatsapp',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_PUSH_NOTIFICATION',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendPushNotification,
        icon: 'fa fa-bell',
      },
    ],
    columns: [
      {
        title: 'Invoice Id',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_id',
        type: 'default',
      },
      {
        title: 'Purchase Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_issue_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'inv_issue_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Invoice #',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_number_prefix',
        type: 'default',
      },
      {
        title: 'Invoice Billing Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_billing_name',
        type: 'default',
      },
      {
        title: 'MEMBER NAME',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_id',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
      {
        title: 'Member Since Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_since',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'clt_since',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Invoice Status',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_status',
        type: 'component',
        data: {
          name: InvoiceStatusComponent,
          additionData: true,
          aData: { fetch_key: 'inv_status' },
        },
      },
      {
        title: 'BALANCE AGE',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_balance_age_in_days',
        type: 'default',
      },
      {
        title: 'BALANCE AGE BUCKET',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'balance_age_bucket',
        type: 'component',
        data: {
          name: BalanceAgeBucketComponent,
          fetch_key: 'balance_age_bucket',
        },
      },
      {
        title: 'Invoice Total Amount',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_total_amt_in_minor_curr',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'inv_total_amt_in_minor_curr',
        },
      },
      {
        title: 'Total Balance Due',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_total_balance_due_in_minor_curr',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'inv_total_balance_due_in_minor_curr',
        },
      },
      {
        title: 'Sales Representative',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_sales_rep',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'inv_sales_rep', originalKey: false },
        },
      },
    ],
  },
  {
    report_key: 'DiscountReport',
    actions: [],
    columns: [
      {
        title: 'MEMBER NAME',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_id',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
      {
        title: 'Invoice #',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_number_prefix',
        type: 'default',
      },
      {
        title: 'Invoice Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_issue_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'inv_issue_date',
            format: 'datetime',
            applytimezone: false,
          },
        },
      },
      {
        title: 'INVOICE TYPE',
        classes: 'py-2  white-space-nowrap',
        dataProperty: 'invline_type',
        type: 'component',
        data: {
          name: InvoiceTypeComponent,
          additionData: true,
          aData: { fetch_key: 'invline_type' },
        },
      },
      {
        title: 'Subscription Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'clt_subs_name_pri_lang',
            secondary: 'clt_subs_name_sec_lang',
          },
        },
      },
      {
        title: 'Offer Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_offer_mst_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'inv_offer_mst_name_pri_lang',
            secondary: 'inv_offer_mst_name_sec_lang',
          },
        },
      },
      {
        title: 'Service Category Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_mbrshp_service_category_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'clt_mbrshp_service_category_name_pri_lang',
            secondary: 'clt_mbrshp_service_category_name_sec_lang',
          },
        },
      },
      {
        title: 'Charge Category Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_chrg_chrgmst_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'clt_chrg_chrgmst_name_pri_lang',
            secondary: 'clt_chrg_chrgmst_name_sec_lang',
          },
        },
      },
      {
        title: 'Amount excluding tax',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'invline_total_taxable_cost_in_minor_curr',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'invline_total_taxable_cost_in_minor_curr',
        },
      },
      {
        title: 'Staff Discount Amount',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'invline_discount_staff_in_minor_curr',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'invline_discount_staff_in_minor_curr',
        },
      },
      {
        title: 'Staff Discount Reason',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'invline_discount_staff_reason',
        type: 'default',
      },
      {
        title: 'Coupon Discount Amount',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'invline_discount_coupon_in_minor_curr',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'invline_discount_coupon_in_minor_curr',
        },
      },
      {
        title: 'Coupon Code',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_coupon_code',
        type: 'default',
      },
      {
        title: 'Discount %',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'discount_percentage',
        type: 'component',
        data: {
          name: PercentageComponent,
          fetch_key: 'discount_percentage',
        },
      },
      {
        title: 'Tax Amount',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'invline_total_tax_in_minor_curr',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'invline_total_tax_in_minor_curr',
        },
      },
      {
        title: 'Total Amount',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'invline_total_amt_in_minor_curr',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'invline_total_amt_in_minor_curr',
        },
      },
      {
        title: 'Member Since Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_since',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'clt_since',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Sales Representative',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_sales_rep',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'inv_sales_rep', originalKey: false },
        },
      },
      {
        title: 'Billed For tenant name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_tenant_id',
        type: 'component',
        data: {
          name: TenantNameComponent,
          additionData: true,
          aData: { fetch_key: 'inv_tenant_id' },
        },
      },
      {
        title: 'Billed at tenant name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_tenant_at_id',
        type: 'component',
        data: {
          name: TenantNameComponent,
          additionData: true,
          aData: { fetch_key: 'inv_tenant_at_id' },
        },
      },
    ],
  },
  {
    report_key: 'TaskDone',
    actions: [
      {
        label: 'TABLE_ACTION_BTNS.CREATE_TASK',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.Task,
        icon: 'fa fa-list',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_EMAIL',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendEmail,
        icon: 'fa fa-envelope',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_SMS',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendSms,
        icon: 'fa fa-comments',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_WHATSAPP',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendWhatsApp,
        icon: 'fab fa-whatsapp',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_PUSH_NOTIFICATION',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendPushNotification,
        icon: 'fa fa-bell',
      },
    ],
    columns: [
      {
        title: 'MEMBER NAME',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_full_name',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
      {
        title: 'Staff',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'stf_id',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'stf_id', originalKey: true },
        },
      },
      {
        title: 'Task Category',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'tsk_categoryid',
        type: 'component',
        data: { name: TaskCategoryCellComponent },
      },
      {
        title: 'Task Type',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'tsk_type',
        type: 'component',
        data: { name: TaskTypeReportComponent },
      },
      {
        title: 'Log Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'log_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'log_date',
            format: 'datetime',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Outcome',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'outcome',
        type: 'component',
        data: { name: OutcomeComponent },
      },
      {
        title: 'Notes',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'notes',
        type: 'default',
      },
      {
        title: 'Reschedule Count',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'tsk_reschedule_count',
        type: 'default',
      },

      {
        title: 'Opportunity ID',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'tsk_opp_id',
        type: 'default',
      },
      {
        title: 'Opportunity Stage name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'opp_stage_mst_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'opp_stage_mst_name_pri_lang',
            secondary: 'opp_stage_mst_name_sec_lang',
          },
        },
      },
    ],
  },
  {
    report_key: 'ClientCreditBalance',
    actions: [
      {
        label: 'TABLE_ACTION_BTNS.CREATE_TASK',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.Task,
        icon: 'fa fa-list',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_EMAIL',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendEmail,
        icon: 'fa fa-envelope',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_SMS',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendSms,
        icon: 'fa fa-comments',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_WHATSAPP',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendWhatsApp,
        icon: 'fab fa-whatsapp',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_PUSH_NOTIFICATION',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendPushNotification,
        icon: 'fa fa-bell',
      },
    ],
    columns: [
      {
        title: 'MEMBER NAME',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_full_name',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
      {
        title: 'Client Since',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_since',
        type: 'default',
      },
      {
        title: 'Client Representative',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_rep_id',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'clt_rep', originalKey: false },
        },
      },
      {
        title: 'Credit Balance in this center',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'current_centre_credit_balance_in_minor_curr',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'current_centre_credit_balance_in_minor_curr',
        },
      },
      {
        title: 'Updated date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'current_centre_credit_balance_last_updated',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'current_centre_credit_balance_last_updated',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Total Credit Balance',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'all_centre_credit_balance_in_minor_curr',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'all_centre_credit_balance_in_minor_curr',
        },
      },
    ],
  },
  {
    report_key: 'MembershipRenewedReport',
    actions: [
      {
        label: 'TABLE_ACTION_BTNS.CREATE_TASK',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.Task,
        icon: 'fa fa-list',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_EMAIL',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendEmail,
        icon: 'fa fa-envelope',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_SMS',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendSms,
        icon: 'fa fa-comments',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_WHATSAPP',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendWhatsApp,
        icon: 'fab fa-whatsapp',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_PUSH_NOTIFICATION',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendPushNotification,
        icon: 'fa fa-bell',
      },
    ],
    columns: [
      {
        title: 'Member Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_id',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
      {
        title: 'Renewal Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'renewal_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'renewal_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Invoice #',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_number_prefix',
        type: 'component',
        data: {
          name: InvoiceDataComponent,
        },
      },
      {
        title: 'Service Category Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_mbrshp_service_category_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'clt_mbrshp_service_category_name_pri_lang',
            secondary: 'clt_mbrshp_service_category_name_sec_lang',
          },
        },
      },
      {
        title: 'Session Owner',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_mbrshp_session_owner_id',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'clt_mbrshp_session_owner', originalKey: false },
        },
      },
      {
        title: 'Client Representative',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_rep_id',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'clt_rep', originalKey: false },
        },
      },
      {
        title: 'Start Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_mbrshp_start_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'clt_mbrshp_start_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'End Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_mbrshp_end_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'clt_mbrshp_end_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Membership Duration (Days)',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'duration_in_days',
        type: 'default',
      },
      {
        title: 'Unused Session',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_mbrshp_unused_sessions',
        type: 'default',
      },
      {
        title: 'Tenant Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_mbrshp_tenant_id',
        type: 'component',
        data: {
          name: TenantNameComponent,
          additionData: true,
          aData: { fetch_key: 'clt_mbrshp_tenant_id' },
        },
      },
    ],
  },
  {
    report_key: 'MembershipExpiredReport',
    actions: [
      {
        label: 'TABLE_ACTION_BTNS.CREATE_TASK',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.Task,
        icon: 'fa fa-list',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_EMAIL',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendEmail,
        icon: 'fa fa-envelope',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_SMS',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendSms,
        icon: 'fa fa-comments',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_WHATSAPP',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendWhatsApp,
        icon: 'fab fa-whatsapp',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_PUSH_NOTIFICATION',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendPushNotification,
        icon: 'fa fa-bell',
      },
    ],
    columns: [
      {
        title: 'Member Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_id',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
      {
        title: 'Invoice #',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_number_prefix',
        type: 'component',
        data: {
          name: InvoiceDataComponent,
        },
      },
      {
        title: 'Service Category Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_mbrshp_service_category_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'clt_mbrshp_service_category_name_pri_lang',
            secondary: 'clt_mbrshp_service_category_name_sec_lang',
          },
        },
      },
      {
        title: 'Session Owner',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_mbrshp_session_owner_id',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'clt_mbrshp_session_owner', originalKey: false },
        },
      },
      {
        title: 'Client Representative',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_rep_id',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'clt_rep', originalKey: false },
        },
      },
      {
        title: 'Start Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_mbrshp_start_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'clt_mbrshp_start_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'End Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_mbrshp_end_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'clt_mbrshp_end_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Membership Duration (Days)',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'duration_in_days',
        type: 'default',
      },
      {
        title: 'Unused Session',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_mbrshp_unused_sessions',
        type: 'default',
      },
      {
        title: 'Life Time Value',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_lifetime_value_in_minor_curr',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'clt_lifetime_value_in_minor_curr',
        },
      },
      {
        title: 'Tenant Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_mbrshp_tenant_id',
        type: 'component',
        data: {
          name: TenantNameComponent,
          additionData: true,
          aData: { fetch_key: 'clt_mbrshp_tenant_id' },
        },
      },
    ],
  },
  {
    report_key: 'CreditBalanceTransactionReport',
    actions: [
      {
        label: 'TABLE_ACTION_BTNS.CREATE_TASK',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.Task,
        icon: 'fa fa-list',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_EMAIL',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendEmail,
        icon: 'fa fa-envelope',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_SMS',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendSms,
        icon: 'fa fa-comments',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_WHATSAPP',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendWhatsApp,
        icon: 'fab fa-whatsapp',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_PUSH_NOTIFICATION',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendPushNotification,
        icon: 'fa fa-bell',
      },
    ],
    columns: [
      {
        title: 'MEMBER NAME',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_id',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
      {
        title: 'Member Since',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_since',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'clt_since',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Client Representative',
        classes: 'py-white-space-nowrap',
        dataProperty: 'clt_rep_id',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'clt_rep', originalKey: false },
        },
      },
      {
        title: 'Source of entry',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'cblt_type',
        type: 'component',
        data: {
          name: CreditBalanceTypeComponent,
          additionData: true,
          aData: { fetch_key: 'cblt_type' },
        },
      },
      {
        title: 'Total Credit Balance',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'cbtl_credit',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'cbtl_credit',
        },
      },
      {
        title: 'Total Debit Amount',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'cbtl_debit',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'cbtl_debit',
        },
      },
      {
        title: 'Total E-wallet Balance',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'cbtl_balance',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'cbtl_balance',
        },
      },
      {
        title: 'Transaction Type',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'credit_balance_transaction_type',
        type: 'component',
        data: {
          name: TransactionTypeComponent,
          additionData: true,
          aData: { fetch_key: 'credit_balance_transaction_type' },
        },
      },
      {
        title: 'Notes',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'cblt_notes',
        type: 'default',
      },
      {
        title: 'Branch Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'tenant_id',
        type: 'component',
        data: {
          name: TenantNameComponent,
          additionData: true,
          aData: { fetch_key: 'tenant_id' },
        },
      },
      {
        title: 'Created date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'cblt_created_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'cblt_created_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Created By',
        classes: 'py-2  white-space-nowrap',
        dataProperty: 'cblt_created_by',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'cblt_created_by', originalKey: false },
        },
      },
    ],
  },
  {
    report_key: 'ClientsByServiceCategory',
    actions: [
      {
        label: 'TABLE_ACTION_BTNS.CREATE_TASK',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.Task,
        icon: 'fa fa-list',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_EMAIL',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendEmail,
        icon: 'fa fa-envelope',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_SMS',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendSms,
        icon: 'fa fa-comments',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_WHATSAPP',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendWhatsApp,
        icon: 'fab fa-whatsapp',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_PUSH_NOTIFICATION',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendPushNotification,
        icon: 'fa fa-bell',
      },
    ],
    columns: [
      {
        title: 'MEMBER NAME',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_id',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
      {
        title: 'Client Status',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_status',
        type: 'component',
        data: { name: ClientStatusComponent },
      },
      {
        title: 'Channel',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_channel',
        type: 'default',
      },
      {
        title: 'Source',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_source',
        type: 'default',
      },
      {
        title: 'Service Category Name',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_mbrshp_service_category_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'clt_mbrshp_service_category_name_pri_lang',
            secondary: 'clt_mbrshp_service_category_name_sec_lang',
          },
        },
      },
      {
        title: 'Client Representative',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_rep_id',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'clt_rep', originalKey: false },
        },
      },
      {
        title: 'Last Updated by ',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_updated_by',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'clt_updated_by', originalKey: false },
        },
      },
      {
        title: 'Updated date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_updated_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'clt_updated_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
    ],
  },
  {
    report_key: 'SalesReturnDetailReport',
    actions: [],
    columns: [
      {
        title: 'MEMBER NAME',
        classes: 'py-2  white-space-nowrap',
        dataProperty: 'clt_id',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
      {
        title: 'Sales Return Date',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'inv_issue_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'sr_return_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Sales Return #',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'sr_number_prefix',
        type: 'default',
      },
      {
        title: 'Invoice #',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'inv_number_prefix',
        type: 'default',
      },
      {
        title: 'Invoice Date',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'inv_issue_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'inv_issue_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Sales return amount',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'invline_total_amt_in_minor_curr',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'srline_total_amt_in_minor_curr',
        },
      },
      {
        title: 'Subscription Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'clt_subs_name_pri_lang',
            secondary: 'clt_subs_name_sec_lang',
          },
        },
      },

      {
        title: 'Service Category Name',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_mbrshp_service_category_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'clt_mbrshp_service_category_name_pri_lang',
            secondary: 'clt_mbrshp_service_category_name_sec_lang',
          },
        },
      },
      {
        title: 'Charge Category Name',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_chrg_chrgmst_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'clt_chrg_chrgmst_name_pri_lang',
            secondary: 'clt_chrg_chrgmst_name_sec_lang',
          },
        },
      },

      {
        title: 'Start Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_mbrshp_start_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'clt_mbrshp_start_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'End Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_mbrshp_end_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'clt_mbrshp_end_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Invoice Amount',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'invline_total_amt_in_minor_curr',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'invline_total_amt_in_minor_curr',
        },
      },
      {
        title: 'Sales Return Sales Representative',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'sr_sales_rep',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'sr_sales_rep', originalKey: false },
        },
      },
      // {
      //   title: 'PAYMENT Amount',
      //   classes: 'py-2 white-space-nowrap',
      //   dataProperty: 'py_inv_link_amount_applied_in_minor_curr',
      //   type: 'component',
      //   data: {
      //     name: CurrencyComponent,
      //     fetch_key: 'py_inv_link_amount_applied_in_minor_curr',
      //   },
      // },
      // {
      //   title: 'BALANCE Amount',
      //   classes: 'py-2 white-space-nowrap',
      //   dataProperty: 'invline_total_balance_in_minor_curr',
      //   type: 'component',
      //   data: {
      //     name: CurrencyComponent,
      //     fetch_key: 'invline_total_balance_in_minor_curr',
      //   },
      // },
      {
        title: 'Created by ',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_created_by',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'inv_created_by', originalKey: false },
        },
      },
      {
        title: 'Sales Representative',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_sales_rep',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'inv_sales_rep', originalKey: false },
        },
      },
    ],
  },
  {
    report_key: 'EmailTransactionReport',
    actions: [],
    columns: [
      {
        title: 'LOG DATE',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'email_trx_log_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'email_trx_log_date',
            format: 'datetime',
            applytimezone: false,
          },
        },
      },
      {
        title: 'CLIENT NAME',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_id',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
      {
        title: 'DIRECTION',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'email_trx_direction',
        type: 'component',
        data: {
          name: CommunicationDirectionComponent,
          additionData: true,
          aData: { fetch_key: 'email_trx_direction' },
        },
      },
      {
        title: 'SENDER',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'email_trx_from',
        type: 'default',
      },
      {
        title: 'RECIPIENT',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'email_trx_to',
        type: 'default',
      },
      {
        title: 'CC',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'email_trx_cc',
        type: 'default',
      },
      {
        title: 'BCC',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'email_trx_bcc',
        type: 'default',
      },
      {
        title: 'SUBJECT',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'email_trx_sub',
        type: 'default',
      },
      {
        title: 'STATUS',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'email_trx_status',
        type: 'component',
        data: {
          name: EmailStatusComponent,
          additionData: true,
          aData: { fetch_key: 'email_trx_status', type: 'email' },
        },
      },
      {
        title: 'FAILED REASON',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'email_trx_status_error_details',
        type: 'default',
      },
      {
        title: 'SENT',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'email_trx_is_sent',
        type: 'component',
        data: {
          name: YesNoComponent,
          additionData: true,
          aData: { fetch_key: 'email_trx_is_sent', type: 'yes-no' },
        },
      },
      {
        title: 'OPENED',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'email_trx_is_opened',
        type: 'component',
        data: {
          name: YesNoComponent,
          additionData: true,
          aData: { fetch_key: 'email_trx_is_opened', type: 'yes-no' },
        },
      },
      {
        title: 'OPENED TIMESTAMP',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'email_trx_open_timestamp',
        type: 'default',
      },
      {
        title: 'CLICKED',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'email_trx_is_clicked',
        type: 'component',
        data: {
          name: YesNoComponent,
          additionData: true,
          aData: { fetch_key: 'email_trx_is_clicked', type: 'yes-no' },
        },
      },
      {
        title: 'CLICKED TIMESTAMP',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'email_trx_click_timestamp',
        type: 'default',
      },
      {
        title: 'UNSUBSCRIBED',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'email_trx_is_unsubscribed',
        type: 'component',
        data: {
          name: YesNoComponent,
          additionData: true,
          aData: { fetch_key: 'email_trx_is_unsubscribed', type: 'yes-no' },
        },
      },
      {
        title: 'REPORTED SPAM',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'email_trx_is_spam',
        type: 'component',
        data: {
          name: YesNoComponent,
          additionData: true,
          aData: { fetch_key: 'email_trx_is_spam', type: 'yes-no' },
        },
      },
      {
        title: 'ATTACHMENT',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'email_has_attachment',
        type: 'component',
        data: {
          name: YesNoComponent,
          additionData: true,
          aData: { fetch_key: 'email_has_attachment', type: 'yes-no' },
        },
      },
      {
        title: 'CAMPAIGN NAME',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'camp_name',
        type: 'default',
      },
      {
        title: 'OWNERSHIP LEVEL',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'email_trx_own_lvl',
        type: 'component',
        data: {
          name: OwnershipLevelComponent,
          additionData: true,
          aData: { fetch_key: 'email_trx_own_lvl' },
        },
      },
      {
        title: 'TENANT NAME',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'email_trx_tenant_id',
        type: 'component',
        data: {
          name: TenantNameComponent,
          additionData: true,
          aData: { fetch_key: 'email_trx_tenant_id' },
        },
      },
      {
        title: 'Created By',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'email_trx_created_by',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'email_trx_created_by', originalKey: false },
        },
      },
      {
        title: 'LOG DATE',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'sms_trx_log_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'email_trx_created_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Updated by',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'email_trx_updated_by',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'email_trx_updated_by', originalKey: false },
        },
      },
      {
        title: 'Updated date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'email_trx_updated_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'email_trx_updated_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
    ],
  },
  {
    report_key: 'SMSTransactionReport',
    actions: [],
    columns: [
      {
        title: 'CLIENT NAME',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_id',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
      {
        title: 'TRANSACTION TYPE',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'sms_trx_type',
        type: 'component',
        data: {
          name: SmsTransactionTypeComponent,
          additionData: true,
          aData: { fetch_key: 'sms_trx_type' },
        },
      },
      {
        title: 'DIRECTION',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'sms_trx_direction',
        type: 'component',
        data: {
          name: CommunicationDirectionComponent,
          additionData: true,
          aData: { fetch_key: 'sms_trx_direction' },
        },
      },
      {
        title: 'SENDER NUMBER',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'sms_trx_sender_id',
        type: 'default',
      },
      {
        title: 'RECIPIENT NUMBER',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'sms_trx_to',
        type: 'default',
      },
      {
        title: 'STATUS',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'sms_trx_status',
        type: 'component',
        data: {
          name: EmailStatusComponent,
          additionData: true,
          aData: { fetch_key: 'sms_trx_status', type: 'email' },
        },
      },
      {
        title: 'FAILED REASON',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'sms_trx_status_error_details',
        type: 'default',
      },
      {
        title: 'OWNERSHIP LEVEL',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'sms_trx_own_lvl',
        type: 'component',
        data: {
          name: OwnershipLevelComponent,
          additionData: true,
          aData: { fetch_key: 'sms_trx_own_lvl' },
        },
      },
      {
        title: 'CAMPAIGN NAME',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'camp_name',
        type: 'default',
      },
      {
        title: 'TENANT NAME',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'sms_trx_tenant_id',
        type: 'component',
        data: {
          name: TenantNameComponent,
          additionData: true,
          aData: { fetch_key: 'sms_trx_tenant_id' },
        },
      },
      {
        title: 'Log Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'sms_trx_log_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'sms_trx_log_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Track Mode',
        classes: ' py-2  white-space-nowrap',
        dataProperty: 'sms_trx_track_mode',
        type: 'component',
        data: {
          name: TrackModeComponent,
          additionData: true,
          aData: { fetch_key: 'sms_trx_track_mode' },
        },
      },
      {
        title: 'Created By',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'sms_trx_created_by',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'sms_trx_created_by', originalKey: false },
        },
      },
      {
        title: 'LOG DATE',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'whatsapp_msg_trx_log_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'sms_trx_created_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Updated by',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'sms_trx_updated_by',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'sms_trx_updated_by', originalKey: false },
        },
      },
      {
        title: 'Updated date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'sms_trx_updated_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'sms_trx_updated_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
    ],
  },
  {
    report_key: 'WhatsAppTransactionReport',
    actions: [],
    columns: [
      {
        title: 'CLIENT NAME',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_id',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
      {
        title: 'DIRECTION',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'whatsapp_msg_trx_direction',
        type: 'component',
        data: {
          name: CommunicationDirectionComponent,
          additionData: true,
          aData: { fetch_key: 'whatsapp_msg_trx_direction' },
        },
      },
      {
        title: 'SENDER NUMBER',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'whatsapp_msg_trx_from_number_id',
        type: 'default',
      },
      {
        title: 'RECIPIENT NUMBER',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'whatsapp_msg_trx_to_number',
        type: 'default',
      },
      {
        title: 'STATUS',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'whatsapp_msg_trx_status',
        type: 'component',
        data: {
          name: EmailStatusComponent,
          additionData: true,
          aData: { fetch_key: 'whatsapp_msg_trx_status', type: 'whatsapp' },
        },
      },
      {
        title: 'OWNERSHIP LEVEL',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'whatsapp_msg_trx_own_lvl',
        type: 'component',
        data: {
          name: OwnershipLevelComponent,
          additionData: true,
          aData: { fetch_key: 'whatsapp_msg_trx_own_lvl' },
        },
      },
      {
        title: 'CAMPAIGN NAME',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'whatsapp_msg_trx_camp_name',
        type: 'default',
      },
      {
        title: 'TENANT NAME',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'whatsapp_msg_trx_tenant_id',
        type: 'component',
        data: {
          name: TenantNameComponent,
          additionData: true,
          aData: { fetch_key: 'whatsapp_msg_trx_tenant_id' },
        },
      },
      {
        title: 'FAILED REASON',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'whatsapp_msg_trx_error_details',
        type: 'default',
      },
      {
        title: 'CREATED BY',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'whatsapp_msg_trx_created_by',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: {
            fetch_key: 'whatsapp_msg_trx_created_by',
            originalKey: false,
          },
        },
      },
      {
        title: 'Created date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'whatsapp_msg_trx_created_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'whatsapp_msg_trx_created_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Updated by',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'whatsapp_msg_trx_updated_by',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: {
            fetch_key: 'whatsapp_msg_trx_updated_by',
            originalKey: false,
          },
        },
      },
      {
        title: 'Updated date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'whatsapp_msg_trx_updated_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'whatsapp_msg_trx_updated_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
    ],
  },
  {
    report_key: 'PaymentTransactionReport',
    actions: [
      {
        label: 'TABLE_ACTION_BTNS.CREATE_TASK',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.Task,
        icon: 'fa fa-list',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_EMAIL',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendEmail,
        icon: 'fa fa-envelope',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_SMS',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendSms,
        icon: 'fa fa-comments',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_WHATSAPP',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendWhatsApp,
        icon: 'fab fa-whatsapp',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_PUSH_NOTIFICATION',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendPushNotification,
        icon: 'fa fa-bell',
      },
    ],
    columns: [
      {
        title: 'Member Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_full_name',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
      {
        title: 'Payment Club',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'tent_id',
        type: 'component',
        data: {
          name: TenantNameComponent,
          additionData: true,
          aData: { fetch_key: 'tent_id' },
        },
      },
      {
        title: 'Payment Mode',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'pymt_log_paymode_level1',
        type: 'component',
        data: {
          name: PaymentModeComponent,
          additionData: true,
          aData: { fetch_key: 'pymt_log_paymode_level1' },
        },
      },
      {
        title: 'Payment Mode',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'pymt_log_paymode_level2',
        type: 'component',
        data: {
          name: PaymentModeComponent,
          additionData: true,
          aData: { fetch_key: 'pymt_log_paymode_level2' },
        },
      },
      {
        title: 'Amount',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'pymt_log_amount_in_minor_curr_from_pgw',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'pymt_log_amount_in_minor_curr_from_pgw',
        },
      },
      {
        title: 'Online Payment',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'pymt_log_is_online',
        type: 'component',
        data: {
          name: OnlineComponent,
          additionData: true,
          aData: { fetch_key: 'pymt_log_is_online' },
        },
      },
      {
        title: 'Auto Pay',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'pymt_log_is_recurring_collection',
        type: 'component',
        data: {
          name: YesNoComponent,
          additionData: true,
          aData: {
            fetch_key: 'pymt_log_is_recurring_collection',
            type: 'yes-no',
          },
        },
      },
      {
        title: 'Invoice Number',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_number_prefix',
        type: 'default',
      },
      {
        title: 'Invoice Balance',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_total_balance_due_in_minor_curr',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'inv_total_balance_due_in_minor_curr',
        },
      },
      {
        title: 'Invoice Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_issue_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'inv_issue_date',
            format: 'datetime',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Payment Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'pymt_payment_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'pymt_payment_date',
            format: 'datetime',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Payment Number',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'pymt_number_prefix',
        type: 'default',
      },
      {
        title: 'Number of Retries',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'ptlil_retry_count',
        type: 'default',
      },
      {
        title: 'Status',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'pymt_log_derived_status',
        type: 'component',
        data: {
          name: PaymentStatusComponent,
          additionData: true,
          aData: {
            fetch_key: 'pymt_log_derived_status',
            status_type: 'payment_derived_status',
          },
        },
      },
      {
        title: 'Failure Reason',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'pymt_log_is_payment_error_reason',
        type: 'default',
      },
      {
        title: 'Created Date',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'pymt_log_created_date',
        type: 'component',
        data: {
          name: DateCellComponent,
          additionData: true,
          aData: { fetch_key: 'pymt_log_created_date', applytimezone: false },
        },
      },
      {
        title: 'Created By',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'pymt_log_created_by',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'pymt_log_created_by', originalKey: false },
        },
      },
    ],
  },
  {
    report_key: 'CountByMemberCategoryWise',
    actions: [
      {
        label: 'TABLE_ACTION_BTNS.CREATE_TASK',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.Task,
        icon: 'fa fa-list',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_EMAIL',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendEmail,
        icon: 'fa fa-envelope',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_SMS',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendSms,
        icon: 'fa fa-comments',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_WHATSAPP',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendWhatsApp,
        icon: 'fab fa-whatsapp',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_PUSH_NOTIFICATION',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendPushNotification,
        icon: 'fa fa-bell',
      },
    ],
    columns: [
      {
        title: 'MEMBER NAME',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_id',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
      {
        title: 'Tenant Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'tent_id',
        type: 'component',
        data: {
          name: TenantNameComponent,
          additionData: true,
          aData: { fetch_key: 'tent_id' },
        },
      },
      {
        title: 'GENDER',
        classes: 'py-2   white-space-nowrap',
        sortable: true,
        filterable: true,
        dataProperty: 'clt_gender',
        type: 'component',
        data: { name: ClientGenderComponent },
      },
      {
        title: 'Execution Period',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'execution_period',
        type: 'default',
      },
      {
        title: 'Service Category',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_mbrshp_service_category_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'clt_mbrshp_service_category_name_pri_lang',
            secondary: 'clt_mbrshp_service_category_name_sec_lang',
          },
        },
      },
    ],
  },
  {
    report_key: 'ClientTrialReport',
    actions: [
      {
        label: 'TABLE_ACTION_BTNS.CREATE_TASK',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.Task,
        icon: 'fa fa-list',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_EMAIL',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendEmail,
        icon: 'fa fa-envelope',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_SMS',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendSms,
        icon: 'fa fa-comments',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_WHATSAPP',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendWhatsApp,
        icon: 'fab fa-whatsapp',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_PUSH_NOTIFICATION',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendPushNotification,
        icon: 'fa fa-bell',
      },
    ],
    columns: [
      {
        title: 'MEMBER NAME',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_id',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
      {
        title: 'Trial Taken In The Period',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'Trials_taken_in_the_period',
        type: 'default',
      },
      {
        title: 'Total Session',
        classes: 'py-2   white-space-nowrap',
        sortable: true,
        filterable: true,
        dataProperty: 'total_session',
        type: 'default',
      },
      {
        title: 'Used Session',
        classes: 'py-2   white-space-nowrap',
        sortable: true,
        filterable: true,
        dataProperty: 'total_used',
        type: 'default',
      },
      {
        title: 'Booked Session',
        classes: 'py-2   white-space-nowrap',
        sortable: true,
        filterable: true,
        dataProperty: 'total_booked',
        type: 'default',
      },
      {
        title: 'Trial Converted',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'trial_converted',
        type: 'component',
        data: {
          name: YesNoComponent,
          additionData: true,
          aData: { fetch_key: 'trial_converted', type: 'yes-no' },
        },
      },
      {
        title: 'Conversion Date',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'conversion_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'conversion_date',
            format: 'datetime',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Plan Name',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_subs_name_pri_lang',
        type: 'default',
      },
      {
        title: 'Plan TCV',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'plan_tcv',
        type: 'default',
      },
    ],
  },
  {
    report_key: 'FreezeReport',
    actions: [
      {
        label: 'TABLE_ACTION_BTNS.CREATE_TASK',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.Task,
        icon: 'fa fa-list',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_EMAIL',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendEmail,
        icon: 'fa fa-envelope',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_SMS',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendSms,
        icon: 'fa fa-comments',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_WHATSAPP',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendWhatsApp,
        icon: 'fab fa-whatsapp',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_PUSH_NOTIFICATION',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendPushNotification,
        icon: 'fa fa-bell',
      },
    ],
    columns: [
      {
        title: 'Tenant Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'subfreeze_tenant_id',
        type: 'component',
        data: {
          name: TenantNameComponent,
          additionData: true,
          aData: { fetch_key: 'tent_id' },
        },
      },
      {
        title: 'Member Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'subfreeze_clt_id',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
      {
        title: 'Freeze Type',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'subfreeze_type',
        type: 'component',
        data: { name: FreezeTypeComponent },
      },
      {
        title: 'Freeze Start Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'subfreeze_start_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'subfreeze_start_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Freeze End Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'subfreeze_end_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'subfreeze_end_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Freeze Occurrence',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'subfreeze_occurence',
        type: 'default',
      },
      {
        title: 'Freeze Status',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'subfreeze_status',
        type: 'component',
        data: { name: FreezeStatusComponent },
      },
      {
        title: 'Freeze Should Be Counted',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'subfreeze_should_be_counted',
        type: 'default',
      },
      {
        title: 'Created by ',
        classes: ' py-2  white-space-nowrap',
        dataProperty: 'subfreeze_created_by',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'subfreeze_created_by', originalKey: false },
        },
      },
      {
        title: 'Freeze Cancelled By',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'subfreeze_cancelled_by',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: {
            fetch_key: 'subfreeze_cancelled_by_stf',
            originalKey: false,
          },
        },
      },
      {
        title: 'Freeze Cancelled Reason',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'subfreeze_cancelled_reason',
        type: 'default',
      },
    ],
  },

  {
    report_key: 'PaymentRunReport',
    actions: [
      {
        label: 'TABLE_ACTION_BTNS.CREATE_TASK',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.Task,
        icon: 'fa fa-list',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_EMAIL',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendEmail,
        icon: 'fa fa-envelope',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_SMS',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendSms,
        icon: 'fa fa-comments',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_WHATSAPP',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendWhatsApp,
        icon: 'fab fa-whatsapp',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_PUSH_NOTIFICATION',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendPushNotification,
        icon: 'fa fa-bell',
      },
    ],
    columns: [
      {
        title: 'MEMBER NAME',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_full_name',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
      {
        title: 'Subscription Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'clt_subs_name_pri_lang',
            secondary: 'clt_subs_name_sec_lang',
          },
        },
      },
      {
        title: 'TOKEN STATUS',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_pay_token_status',
        type: 'component',
        data: {
          name: PaymentTokenStatusComponent,
          additionData: true,
          aData: { fetch_key: 'clt_pay_token_status' },
        },
      },
      {
        title: 'Subscription Start Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_start_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'clt_subs_start_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Scheduled charge date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_sub_recurr_bill_occ_start_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'clt_sub_recurr_bill_occ_start_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Charge Status ',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'payrun_derived_status',
        type: 'component',
        data: {
          name: PaymentStatusComponent,
          additionData: true,
          aData: {
            fetch_key: 'payrun_derived_status',
            status_type: 'payrun_derived_status',
          },
        },
      },
      {
        title: 'Tax Amount',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_total_tax_amt_in_minor_curr',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'inv_total_tax_amt_in_minor_curr',
        },
      },
      {
        title: 'Total Amount',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_total_amt_in_minor_curr',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'inv_total_amt_in_minor_curr',
        },
      },
      {
        title: 'Base Amount',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_total_base_amt_in_minor_curr',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'inv_total_base_amt_in_minor_curr',
        },
      },
      {
        title: 'Retry',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'ptlil_retry_count',
        type: 'default',
      },
      {
        title: 'Next Retry Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_next_retry_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'inv_next_retry_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Failure Reason',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'pymt_log_is_payment_error_reason',
        type: 'default',
      },
      {
        title: 'Transaction Type',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'ptlil_retry_method',
        type: 'component',
        data: {
          name: RetryModeComponent,
          additionData: true,
          aData: { fetch_key: 'ptlil_retry_method' },
        },
      },
      {
        title: 'PAYMENT MODE',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'pymt_log_paymode_level2_id',
        type: 'component',
        data: {
          name: PaymentModeComponent,
          additionData: true,
          aData: { fetch_key: 'pymt_log_paymode_level2_id' },
        },
      },
      {
        title: 'Tenant Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_tenant_id',
        type: 'component',
        data: {
          name: TenantNameComponent,
          additionData: true,
          aData: { fetch_key: 'clt_subs_tenant_id' },
        },
      },
    ],
  },
  {
    report_key: 'RefundReport',
    actions: [
      {
        label: 'TABLE_ACTION_BTNS.CREATE_TASK',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.Task,
        icon: 'fa fa-list',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_EMAIL',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendEmail,
        icon: 'fa fa-envelope',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_SMS',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendSms,
        icon: 'fa fa-comments',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_WHATSAPP',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendWhatsApp,
        icon: 'fab fa-whatsapp',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_PUSH_NOTIFICATION',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendPushNotification,
        icon: 'fa fa-bell',
      },
    ],
    columns: [
      {
        title: 'Refund Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'refundpymt_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'refundpymt_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Refund Number',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'refundpymt_number_prefix',
        type: 'default',
      },
      {
        title: 'Original Invoice #',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_number_prefix',
        type: 'component',
        data: {
          name: InvoiceDataComponent,
        },
      },
      {
        title: 'Original Payment #',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'pymt_number_prefix',
        type: 'component',
        data: {
          name: InvoiceDataComponent,
        },
      },
      {
        title: 'Origional Invoice Amount',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_total_amt_in_minor_curr',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'inv_total_amt_in_minor_curr',
        },
      },
      {
        title: 'INVOICE DATE',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_issue_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'inv_issue_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Origional Payment Amount',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'pymt_amount_in_minor_curr',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'pymt_amount_in_minor_curr',
        },
      },
      {
        title: 'PAYMENT DATE',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'pymt_payment_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'pymt_payment_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Payment Mode Level 1',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'pymt_paymode_level1',
        type: 'component',
        data: {
          name: PaymentModeComponent,
          additionData: true,
          aData: { fetch_key: 'pymt_paymode_level1' },
        },
      },
      {
        title: 'Payment Mode Level 2',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'pymt_paymode_level2_id',
        type: 'component',
        data: {
          name: PaymentModeComponent,
          additionData: true,
          aData: { fetch_key: 'pymt_paymode_level2_id' },
        },
      },
      {
        title: 'MEMBER NAME',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_full_name',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
      {
        title: 'Refund Amount',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'refundpymt_amount_in_minor_curr',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'refundpymt_amount_in_minor_curr',
        },
      },
      {
        title: 'Refund Status',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'refundpymt_status',
        type: 'component',
        data: {
          name: RefundStatusComponent,
          additionData: true,
          aData: { fetch_key: 'refundpymt_status' },
        },
      },
      {
        title: 'Refund by',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'refundpymt_sales_rep_stf_id',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'refundpymt_sales_rep', originalKey: false },
        },
      },
      {
        title: 'Is Online Refund',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'refundpymt_is_online',
        type: 'component',
        data: {
          name: YesNoComponent,
          additionData: true,
          aData: { fetch_key: 'refundpymt_is_online', type: 'stringboolean' },
        },
      },
      {
        title: 'Refund Mode',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'paymodemst_name_pri_lang',
        type: 'default',
      },
      {
        title: 'Refund Mode Level 1',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'refundpymt_mode_level1',
        type: 'component',
        data: {
          name: PaymentModeComponent,
          additionData: true,
          aData: { fetch_key: 'refundpymt_mode_level1' },
        },
      },
      {
        title: 'Refund Mode Level 2',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'refundpymt_mode_level2_id',
        type: 'component',
        data: {
          name: PaymentModeComponent,
          additionData: true,
          aData: { fetch_key: 'refundpymt_mode_level2_id' },
        },
      },
      {
        title: 'Refund Reason',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'refundpymt_reason',
        type: 'component',
        data: {
          name: RefundReasonComponent,
          additionData: true,
          aData: { fetch_key: 'refundpymt_reason' },
        },
      },
      {
        title: 'Refund Comments',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'refundpymt_comments',
        type: 'default',
      },
      {
        title: 'Refund is Voided',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'refundpymt_is_void',
        type: 'component',
        data: {
          name: YesNoComponent,
          additionData: true,
          aData: { fetch_key: 'refundpymt_is_void', type: 'stringboolean' },
        },
      },
    ],
  },

  {
    report_key: 'RecognizedRevenueDetails',
    actions: [
      {
        label: 'TABLE_ACTION_BTNS.CREATE_TASK',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.Task,
        icon: 'fa fa-list',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_EMAIL',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendEmail,
        icon: 'fa fa-envelope',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_SMS',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendSms,
        icon: 'fa fa-comments',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_WHATSAPP',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendWhatsApp,
        icon: 'fab fa-whatsapp',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_PUSH_NOTIFICATION',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendPushNotification,
        icon: 'fa fa-bell',
      },
    ],
    columns: [
      {
        title: 'Tenant Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'subfreeze_tenant_id',
        type: 'component',
        data: {
          name: TenantNameComponent,
          additionData: true,
          aData: { fetch_key: 'tent_id' },
        },
      },
      {
        title: 'Member Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_id',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
      {
        title: 'Invoice #',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'invoice_prefix',
        type: 'component',
        data: {
          name: InvoiceDataComponent,
        },
      },
      {
        title: 'INVOICE DATE',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_issue_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'inv_issue_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Sales Rep',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'sales_rep_id',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'sales_rep_id', originalKey: false },
        },
      },
      {
        title: 'Revenue Recognized Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'rev_recognition_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'rev_recognition_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Recognized Amount',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'recognized_amount',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'recognized_amount',
        },
      },
      {
        title: 'Freeze End Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'subfreeze_end_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'subfreeze_end_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Item name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'item_name',
        type: 'default',
      },
    ],
  },

  {
    report_key: 'DeferredRevenueDetails',
    actions: [
      {
        label: 'TABLE_ACTION_BTNS.CREATE_TASK',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.Task,
        icon: 'fa fa-list',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_EMAIL',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendEmail,
        icon: 'fa fa-envelope',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_SMS',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendSms,
        icon: 'fa fa-comments',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_WHATSAPP',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendWhatsApp,
        icon: 'fab fa-whatsapp',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_PUSH_NOTIFICATION',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendPushNotification,
        icon: 'fa fa-bell',
      },
    ],
    columns: [
      {
        title: 'Tenant Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'subfreeze_tenant_id',
        type: 'component',
        data: {
          name: TenantNameComponent,
          additionData: true,
          aData: { fetch_key: 'tent_id' },
        },
      },
      {
        title: 'Member Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_id',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
      {
        title: 'Invoice #',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'invoice_prefix',
        type: 'component',
        data: {
          name: InvoiceDataComponent,
        },
      },
      {
        title: 'INVOICE DATE',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'inv_issue_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'inv_issue_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Sales Rep',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'sales_rep_id',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'sales_rep_id', originalKey: false },
        },
      },
      {
        title: 'Revenue Recognized Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'rev_recognition_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'rev_recognition_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Recognized Amount',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'recognized_amount',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'recognized_amount',
        },
      },
      {
        title: 'Freeze End Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'subfreeze_end_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'subfreeze_end_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Item name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'item_name',
        type: 'default',
      },
    ],
  },

  {
    report_key: 'StockInventoryReport',
    actions: [],
    columns: [
      {
        title: 'Tenant Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'tenant_id',
        type: 'component',
        data: {
          name: TenantNameComponent,
          additionData: true,
          aData: { fetch_key: 'tenant_id' },
        },
      },
      {
        title: 'Brand Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'brand_name_pri_lang',
        type: 'default',
      },
      {
        title: 'Product Category Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'prod_cat_pri_name',
        type: 'default',
      },
      {
        title: 'Product Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'prod_name_pri_lang',
        type: 'default',
      },
      {
        title: 'Product Code',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'prod_code',
        type: 'default',
      },
      {
        title: 'SKU Code',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'sku_code',
        type: 'default',
      },
      {
        title: 'SKU Unit Price',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'sku_unit_price_minor',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'sku_unit_price_minor',
        },
      },
      {
        title: 'SKU Cost Price',
        classes: 'py-2 white-sku_cost_price_minor',
        dataProperty: 'sku_cost_price_minor',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'sku_cost_price_minor',
        },
      },
      {
        title: 'Quantity On Hand',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'quantity_on_hand',
        type: 'default',
      },
      {
        title: 'Status',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'sku_is_active',
        type: 'component',
        data: {
          name: YesNoComponent,
          additionData: true,
          aData: { fetch_key: 'sku_is_active', type: 'booleanactiveinactive' },
        },
      },
    ],
  },
  {
    report_key: 'RetailSalesByProductReport',
    actions: [],
    columns: [
      {
        title: 'Category Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'category_name',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'category_name',
            secondary: 'category_name_sec_lang',
          },
        },
      },
      {
        title: 'Product Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'product_name',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'product_name',
            secondary: 'product_name_sec_lang',
          },
        },
      },
      {
        title: 'SKU Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'sku_name',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'sku_name',
            secondary: 'sku_name_sec_lang',
          },
        },
      },
      {
        title: 'SKU ID',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'sku_id',
        type: 'default',
      },
      {
        title: 'Barcode',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'barcode',
        type: 'default',
      },
      {
        title: 'Attributes',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'attributes',
        type: 'default',
      },
      {
        title: 'Qty',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'quantity',
        type: 'default',
      },
      {
        title: 'Total $',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'total_revenue',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'total_revenue',
        },
      },
      {
        title: 'Average Selling Price',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'average_selling_price',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'average_selling_price',
        },
      },
    ],
  },
  {
    report_key: 'RetailSalesByStaffReport',
    actions: [],
    columns: [
      {
        title: 'Staff Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'staff_name',
        type: 'default',
      },
      {
        title: 'Category Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'category_name',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'category_name',
            secondary: 'category_name_sec_lang',
          },
        },
      },
      {
        title: 'Product Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'product_name',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'product_name',
            secondary: 'product_name_sec_lang',
          },
        },
      },
      {
        title: 'SKU Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'sku_name',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'sku_name',
            secondary: 'sku_name_sec_lang',
          },
        },
      },
      {
        title: 'SKU ID',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'sku_id',
        type: 'default',
      },
      {
        title: 'Barcode',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'barcode',
        type: 'default',
      },
      {
        title: 'Attributes',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'attributes',
        type: 'default',
      },
      {
        title: 'Qty',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'quantity',
        type: 'default',
      },
      {
        title: 'Total $',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'total_revenue',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'total_revenue',
        },
      },
      {
        title: 'Average Selling Price',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'average_selling_price',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'average_selling_price',
        },
      },
    ],
  },
  {
    report_key: 'RetailStockMovementReport',
    actions: [],
    columns: [
      {
        title: 'Barcode',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'barcode',
        type: 'default',
      },
      {
        title: 'SKU Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'sku_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'sku_name_pri_lang',
            secondary: 'sku_name_sec_lang',
          },
        },
      },
      {
        title: 'Adjustment Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'adjustment_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'adjustment_date',
            format: 'datetime',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Movement Type',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'movement_type',
        type: 'default',
      },
      {
        title: 'Quantity',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'quantity',
        type: 'default',
      },
      {
        title: 'Supplier Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'supplier_name',
        type: 'default',
      },
      {
        title: 'Attributes',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'attributes',
        type: 'default',
      },
      {
        title: 'Cost Price',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'cost_price',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'cost_price',
        },
      },
      {
        title: 'Reason',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'reason',
        type: 'default',
      },
      {
        title: 'Document Type',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'document_type',
        type: 'default',
      },
      {
        title: 'Document ID',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'document_id',
        type: 'default',
      },
    ],
  },
  {
    report_key: 'SessionLiabilityAndUtilizationReport',
    actions: [
      {
        label: 'TABLE_ACTION_BTNS.CREATE_TASK',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.Task,
        icon: 'fa fa-list',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_EMAIL',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendEmail,
        icon: 'fa fa-envelope',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_SMS',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendSms,
        icon: 'fa fa-comments',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_WHATSAPP',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendWhatsApp,
        icon: 'fab fa-whatsapp',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_PUSH_NOTIFICATION',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendPushNotification,
        icon: 'fa fa-bell',
      },
    ],
    columns: [
      {
        title: 'Tenant Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'tent_id',
        type: 'component',
        data: {
          name: TenantNameComponent,
          additionData: true,
          aData: { fetch_key: 'tent_id' },
        },
      },
      {
        title: 'MEMBER NAME',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_id',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
      {
        title: 'Subscription Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'clt_subs_name_pri_lang',
            secondary: 'clt_subs_name_sec_lang',
          },
        },
      },
      {
        title: 'Membership Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_mbrshp_service_category_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'clt_mbrshp_service_category_name_pri_lang',
            secondary: 'clt_mbrshp_service_category_name_sec_lang',
          },
        },
      },
      {
        title: 'Session Owner',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_mbrshp_session_owner_stf_id',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'clt_mbrshp_session_owner', originalKey: false },
        },
      },
      {
        title: 'Total Session',
        classes: 'py-2   white-space-nowrap',
        sortable: true,
        filterable: true,
        dataProperty: 'total_session',
        type: 'default',
      },
      {
        title: 'Attended',
        classes: 'py-2   white-space-nowrap',
        sortable: true,
        filterable: true,
        dataProperty: 'clt_mbrshp_used_sessions',
        type: 'default',
      },
      {
        title: 'No Show',
        classes: 'py-2   white-space-nowrap',
        sortable: true,
        filterable: true,
        dataProperty: 'clt_mbrshp_noshow_sessions',
        type: 'default',
      },
      {
        title: 'Booked Session',
        classes: 'py-2   white-space-nowrap',
        sortable: true,
        filterable: true,
        dataProperty: 'clt_mbrshp_booked_session',
        type: 'default',
      },
      {
        title: 'Unbooked Sessions (Available sessions)',
        classes: 'py-2   white-space-nowrap',
        sortable: true,
        filterable: true,
        dataProperty: 'clt_mbrshp_available_sessions',
        type: 'default',
      },
      {
        title: 'Adjusted Sessions',
        classes: 'py-2   white-space-nowrap',
        sortable: true,
        filterable: true,
        dataProperty: 'clt_mbrshp_session_carry_forward',
        type: 'default',
      },
    ],
  },
  {
    report_key: 'LostOpportunities',
    actions: [
      {
        label: 'TABLE_ACTION_BTNS.CREATE_TASK',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.Task,
        icon: 'fa fa-list',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_EMAIL',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendEmail,
        icon: 'fa fa-envelope',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_SMS',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendSms,
        icon: 'fa fa-comments',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_WHATSAPP',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendWhatsApp,
        icon: 'fab fa-whatsapp',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_PUSH_NOTIFICATION',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendPushNotification,
        icon: 'fa fa-bell',
      },
    ],
    columns: [
      {
        title: 'Tenant Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'tent_id',
        type: 'component',
        data: {
          name: TenantNameComponent,
          additionData: true,
          aData: { fetch_key: 'tent_id' },
        },
      },
      {
        title: 'MEMBER NAME',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_full_name',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
      {
        title: 'Opportunity name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'opp_name',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: { primary: 'opp_name', secondary: 'opp_name' },
        },
      },
      {
        title: 'Assigned To Staff',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'opp_assigned_to_stf_id',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'opp_assigned_to', originalKey: false },
        },
      },
      {
        title: 'Amount',
        classes: 'py-2 white-sku_cost_price_minor',
        dataProperty: 'opp_value_in_minor_currency',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'opp_value_in_minor_currency',
        },
      },
      {
        title: 'Comments',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'opp_comments',
        type: 'default',
      },
      {
        title: 'Reason type',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'opp_lost_reason_type',
        type: 'component',
        data: { name: LostReasonTypeComponent },
      },
      {
        title: 'Reason Other',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'opp_lost_reason_other',
        type: 'default',
      },
      {
        title: 'Lost To Competitor',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'opp_lost_competitor',
        type: 'default',
      },
      {
        title: 'Contract End Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'opp_lost_contract_end_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'opp_lost_contract_end_date',
            format: 'datetime',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Lost Expected Value',
        classes: 'py-2 white-sku_cost_price_minor',
        dataProperty: 'opp_lost_expected_price_in_minor_currency',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'opp_lost_expected_price_in_minor_currency',
        },
      },
      {
        title: 'Comment',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'opp_lost_comments',
        type: 'default',
      },
      {
        title: 'Board Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'opp_board_type',
        type: 'component',
        data: { name: StageNameComponent },
      },
      {
        title: 'Created date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'opp_created_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'opp_created_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Created By',
        classes: 'py-2  white-space-nowrap',
        dataProperty: 'opp_created_by_stf_id',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'opp_created_by', originalKey: false },
        },
      },
      {
        title: 'Updated date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'opp_updated_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'opp_updated_date',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Updated By',
        classes: 'py-2  white-space-nowrap',
        dataProperty: 'opp_updated_by_stf_id',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'opp_updated_by', originalKey: false },
        },
      },
    ],
  },
  {
    report_key: 'GuestPassUtilizationReport',
    actions: [
      {
        label: 'TABLE_ACTION_BTNS.CREATE_TASK',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.Task,
        icon: 'fa fa-list',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_EMAIL',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendEmail,
        icon: 'fa fa-envelope',
      },
    ],
    columns: [
      {
        title: 'Tenant Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'tent_id',
        type: 'component',
        data: {
          name: TenantNameComponent,
          additionData: true,
          aData: { fetch_key: 'tent_id' },
        },
      },
      // {
      //   title: 'MEMBER NAME',
      //   classes: 'py-2 white-space-nowrap',
      //   dataProperty: 'clt_full_name',
      //   type: 'component',
      //   data: { name: ProspectInfoComponent },
      // },
      {
        title: 'Guest Client',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'grp_guest_clt_full_name',
        type: 'component',
        data: {
          name: ClientInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'grp_guest' },
        },
      },
      {
        title: 'Host Client',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'grp_host_clt_full_name',
        type: 'component',
        data: {
          name: ClientInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'grp_host' },
        },
      },
      {
        title: 'Subscription Name',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_subs_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'clt_subs_name_pri_lang',
            secondary: 'clt_subs_name_sec_lang',
          },
        },
      },
      {
        title: 'Subscription Status',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_status',
        type: 'component',
        data: { name: SubscriptionStatusComponent },
      },
      {
        title: 'Checkin Time',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'grp_checked_in_datetime',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'grp_checked_in_datetime',
            format: 'datetime',
            applytimezone: false,
          },
        },
      },
      {
        title: 'status',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'grp_status',
        type: 'component',
        data: {
          name: GuestPassStatusComponent,
          additionData: true,
          aData: { fetch_key: 'grp_status' },
        },
      },
    ],
  },
  {
    report_key: 'ClassLateCancellationAndNoShowReport',
    actions: [
      {
        label: 'TABLE_ACTION_BTNS.CREATE_TASK',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.Task,
        icon: 'fa fa-list',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_EMAIL',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendEmail,
        icon: 'fa fa-envelope',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_SMS',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendSms,
        icon: 'fa fa-comments',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_WHATSAPP',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendWhatsApp,
        icon: 'fab fa-whatsapp',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_PUSH_NOTIFICATION',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendPushNotification,
        icon: 'fa fa-bell',
      },
    ],
    columns: [
      // {
      //   title: 'Date',
      //   classes: 'py-2 white-space-nowrap',
      //   dataProperty: 'class_start_datetime',
      //   type: 'component',
      //   data: {
      //     name: DateFormatedComponent,
      //     additionData: true,
      //     aData: {
      //       KeyName: 'class_start_datetime',
      //       format: 'datetime',
      //       applytimezone: false,
      //     },
      //   },
      // },
      {
        title: 'MEMBER NAME',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_full_name',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
      {
        title: 'Class Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'class_type_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'class_type_name_pri_lang',
            secondary: 'class_type_name_sec_lang',
            color: 'class_type_color',
          },
        },
      },
      {
        title: 'Class Subtype Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'class_subtype_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'class_subtype_name_pri_lang',
            secondary: 'class_subtype_name_sec_lang',
            color: 'class_type_color',
          },
        },
      },
      {
        title: 'Class Behaviour',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'class_behaviour',
        type: 'component',
        data: { name: BehaviourViewComponent },
      },
      {
        title: 'Class Start Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'class_start_datetime',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'class_start_datetime',
            format: 'datetime',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Class End Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'class_end_datetime',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'class_end_datetime',
            format: 'datetime',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Coach',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'class_coach',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'class_coach', originalKey: false },
        },
      },
      {
        title: 'No show / Late Cancel ',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'no_show_late_cancel',
        type: 'default',
      },
      {
        title: 'Total Exemptions',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_noshow_late_cancel_limit_per_year',
        type: 'default',
      },
      {
        title: 'Subscription Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'clt_subs_name_pri_lang',
            secondary: 'clt_subs_name_sec_lang',
          },
        },
      },
      {
        title: 'Action',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'action',
        type: 'component',
        data: {
          name: ActionsComponent,
          additionData: true,
          aData: [
            'create_charge'
          ],
        },
      }
    ],
  },
  {
    report_key: 'UnpaidClassBookingReport',
    actions: [
      {
        label: 'TABLE_ACTION_BTNS.CREATE_TASK',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.Task,
        icon: 'fa fa-list',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_EMAIL',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendEmail,
        icon: 'fa fa-envelope',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_SMS',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendSms,
        icon: 'fa fa-comments',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_WHATSAPP',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendWhatsApp,
        icon: 'fab fa-whatsapp',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_PUSH_NOTIFICATION',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendPushNotification,
        icon: 'fa fa-bell',
      },
    ],
    columns: [
      {
        title: 'Class Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'class_type_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'class_type_name_pri_lang',
            secondary: 'class_type_name_sec_lang',
            color: 'class_type_color',
          },
        },
      },
      {
        title: 'Class Subtype Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'class_subtype_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'class_subtype_name_pri_lang',
            secondary: 'class_subtype_name_sec_lang',
            color: 'class_type_color',
          },
        },
      },
      {
        title: 'Class Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'class_start_datetime',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'class_start_datetime',
            format: 'defaultformat',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Start Time',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'class_start_datetime',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'class_start_datetime',
            format: 'shortTime',
            applytimezone: false,
          },
        },
      },
      {
        title: 'End Time',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'class_end_datetime',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'class_end_datetime',
            format: 'shortTime',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Class Behaviour',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'class_behaviour',
        type: 'component',
        data: { name: BehaviourViewComponent },
      },
      {
        title: 'Coach',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'class_coach',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'class_coach', originalKey: false },
        },
      },
      {
        title: 'MEMBER NAME',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_id',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
      {
        title: 'Booking status',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'class_booking_status',
        type: 'component',
        data: { name: ClassBookingStatusComponent },
      },
      {
        title: 'First Time booked',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'class_booking_is_first_time_class',
        type: 'component',
        data: {
          name: YesNoComponent,
          additionData: true,
          aData: {
            fetch_key: 'class_booking_is_first_time_class',
            type: 'yes-no',
          },
        },
      },
      {
        title: 'Unpaid',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'unpaid',
        type: 'component',
        data: {
          name: YesNoComponent,
          additionData: true,
          aData: {
            fetch_key: 'unpaid',
            type: 'yes-no',
          },
        },
      },
      {
        title:'Class Pass',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'class_pass',
        type: 'component',
        data: { name: ClassPassComponent },
      },
      {
        title: 'Subscription name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'clt_subs_name_pri_lang',
            secondary: 'clt_subs_name_sec_lang',
          },
        },
      },
      {
        title: 'Sessions Revenue',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'class_booking_session_revenue',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'class_booking_session_revenue',
        },
      },
    ],
  },
  {
    report_key: 'classRatingSummaryReport',
    actions: [],
    columns: [
      {
        title: 'Class Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'class_type_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'class_type_name_pri_lang',
            secondary: 'class_type_name_sec_lang',
            color: 'class_type_color',
          },
        },
      },
      {
        title: 'Behaviour',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'class_type_behaviour',
        type: 'component',
        data: { name: BehaviourViewComponent },
      },
      {
        title: '1 Star',
        classes: 'py-2 white-space-nowrap',
        dataProperty: '1_star',
        type: 'default',
      },
      {
        title: '2 Star',
        classes: 'py-2 white-space-nowrap',
        dataProperty: '2_star',
        type: 'default',
      },
      {
        title: '3 Star',
        classes: 'py-2 white-space-nowrap',
        dataProperty: '3_star',
        type: 'default',
      },
      {
        title: '4 Star',
        classes: 'py-2 white-space-nowrap',
        dataProperty: '4_star',
        type: 'default',
      },
      {
        title: '5 Star',
        classes: 'py-2 white-space-nowrap',
        dataProperty: '5_star',
        type: 'default',
      },
    ],
  },
  {
    report_key: 'classRatingByCoachSummaryReport',
    actions: [],
    columns: [
      {
        title: 'Class Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'class_type_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'class_type_name_pri_lang',
            secondary: 'class_type_name_sec_lang',
            color: 'class_type_color',
          },
        },
      },
      {
        title: 'Behaviour',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'class_type_behaviour',
        type: 'component',
        data: { name: BehaviourViewComponent },
      },
      {
        title: 'Coach',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'class_coach',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'class_coach', originalKey: false },
        },
      },
      {
        title: '1 Star',
        classes: 'py-2 white-space-nowrap',
        dataProperty: '1_star',
        type: 'default',
      },
      {
        title: '2 Star',
        classes: 'py-2 white-space-nowrap',
        dataProperty: '2_star',
        type: 'default',
      },
      {
        title: '3 Star',
        classes: 'py-2 white-space-nowrap',
        dataProperty: '3_star',
        type: 'default',
      },
      {
        title: '4 Star',
        classes: 'py-2 white-space-nowrap',
        dataProperty: '4_star',
        type: 'default',
      },
      {
        title: '5 Star',
        classes: 'py-2 white-space-nowrap',
        dataProperty: '5_star',
        type: 'default',
      },
    ],
  },
  {
    report_key: 'AppointmentRatingSummaryReport',
    actions: [],
    columns: [
      {
        title: 'Appointment name',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'appt_type_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'appt_type_name_pri_lang',
            secondary: 'appt_type_name_sec_lang',
            color: 'appt_type_color',
          },
        },
      },
      {
        title: 'Behaviour',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'appt_type_behaviour',
        type: 'component',
        data: { name: BehaviourViewComponent },
      },
      {
        title: '1 Star',
        classes: 'py-2 white-space-nowrap',
        dataProperty: '1_star',
        type: 'default',
      },
      {
        title: '2 Star',
        classes: 'py-2 white-space-nowrap',
        dataProperty: '2_star',
        type: 'default',
      },
      {
        title: '3 Star',
        classes: 'py-2 white-space-nowrap',
        dataProperty: '3_star',
        type: 'default',
      },
      {
        title: '4 Star',
        classes: 'py-2 white-space-nowrap',
        dataProperty: '4_star',
        type: 'default',
      },
      {
        title: '5 Star',
        classes: 'py-2 white-space-nowrap',
        dataProperty: '5_star',
        type: 'default',
      },
    ],
  },
  {
    report_key: 'AppointmentRatingByCoachSummaryReport',
    actions: [],
    columns: [
      {
        title: 'Appointment Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'appt_type_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'appt_type_name_pri_lang',
            secondary: 'appt_type_name_sec_lang',
            color: 'appt_type_color',
          },
        },
      },
      {
        title: 'Behaviour',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'appt_type_behaviour',
        type: 'component',
        data: { name: BehaviourViewComponent },
      },
      {
        title: 'Coach',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'appt_coach',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'appt_coach', originalKey: false },
        },
      },
      {
        title: '1 Star',
        classes: 'py-2 white-space-nowrap',
        dataProperty: '1_star',
        type: 'default',
      },
      {
        title: '2 Star',
        classes: 'py-2 white-space-nowrap',
        dataProperty: '2_star',
        type: 'default',
      },
      {
        title: '3 Star',
        classes: 'py-2 white-space-nowrap',
        dataProperty: '3_star',
        type: 'default',
      },
      {
        title: '4 Star',
        classes: 'py-2 white-space-nowrap',
        dataProperty: '4_star',
        type: 'default',
      },
      {
        title: '5 Star',
        classes: 'py-2 white-space-nowrap',
        dataProperty: '5_star',
        type: 'default',
      },
    ],
  },
  {
    report_key: 'GuestPassUtilizationAndLiabilityReport',
    actions: [
      {
        label: 'TABLE_ACTION_BTNS.CREATE_TASK',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.Task,
      },
    ],
    columns: [
      {
        title: 'Tenant Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'tent_id',
        type: 'component',
        data: {
          name: TenantNameComponent,
          additionData: true,
          aData: { fetch_key: 'tent_id' },
        },
      },
      {
        title: 'MEMBER NAME',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_full_name',
        type: 'component',
        data: { name: ProspectInfoComponent },
      },
      {
        title: 'Subscription Name',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'clt_subs_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'clt_subs_name_pri_lang',
            secondary: 'clt_subs_name_sec_lang',
          },
        },
      },
      {
        title: 'Subscription Status',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_status',
        type: 'component',
        data: { name: SubscriptionStatusComponent },
      },
      {
        title: 'Total Booked',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'cgpi_total_booked',
        type: 'default',
      },
      {
        title: 'Total Attended',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'cgpi_total_attended',
        type: 'default',
      },
      {
        title: 'Total No Shows',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'cgpi_total_noshow',
        type: 'default',
      },
      {
        title: 'Total Available',
        classes: 'py-2   white-space-nowrap',
        dataProperty: 'cgpi_total_available',
        type: 'default',
      },
    ],
  },
  {
    report_key: 'ClientReferralReport',
    actions: [
      {
        label: 'TABLE_ACTION_BTNS.CREATE_TASK',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.Task,
        icon: 'fa fa-list',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_EMAIL',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendEmail,
        icon: 'fa fa-envelope',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_SMS',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendSms,
        icon: 'fa fa-comments',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_WHATSAPP',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendWhatsApp,
        icon: 'fab fa-whatsapp',
      },
      {
        label: 'TABLE_ACTION_BTNS.SEND_PUSH_NOTIFICATION',
        class: 'p-button-text text-sm mr-1',
        type: 'button',
        actionType: TableAction.SendPushNotification,
        icon: 'fa fa-bell',
      },
    ],
    columns: [
      {
        title: 'Referral Date',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_ref_created_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'clt_ref_created_date',
            format: 'datetime',
            applytimezone: false,
          },
        },
      },
      {
        title: 'Referring Member - Client Rep',
        classes: 'py-2  white-space-nowrap',
        dataProperty: 'clt_ref_referrer_clt_rep_stf_id',
        type: 'component',
        data: {
          name: StaffInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'clt_ref_referrer_clt_rep', originalKey: false },
        },
      },
      {
        title: 'Referring Member',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_ref_referrer_clt_id',
        type: 'component',
        data: {
          name: ClientInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'clt_ref_referrer' },
        },
      },
      {
        title: 'Referred Member',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_ref_referee_clt_id',
        type: 'component',
        data: {
          name: ClientInfoReportComponent,
          additionData: true,
          aData: { fetch_key: 'clt_ref_referee' },
        },
      },
      {
        title: 'Referral Status',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_ref_status',
        type: 'component',
        data: {
          name: ReferralStatusComponent,
          additionData: true,
          aData: { fetch_key: 'clt_ref_status' },
        },
      },
      {
        title: 'Subscription Name',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'clt_subs_name_pri_lang',
        type: 'component',
        data: {
          name: PrimarySecondaryComponent,
          additionData: true,
          aData: {
            primary: 'clt_subs_name_pri_lang',
            secondary: 'clt_subs_name_sec_lang',
          },
        },
      },
      {
        title: 'TENANT NAME',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'tent_id',
        type: 'component',
        data: {
          name: TenantNameComponent,
          additionData: true,
          aData: { fetch_key: 'tent_id' },
        },
      }
    ],
  }
];
